import { asNativeElements, Component, HostListener, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import _moment from 'proxies/dayjs';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ThisReceiver } from '@angular/compiler';
import { truncate } from 'fs';

//Questionnaires the payer will not accept a partial answer to: every question on one has to be answered
//before the request can be submitted. They are named by the questionnaire's own text - the plan's
//canonical URL for it - rather than by title, which is free text and differs between payers.
//The hie_supporting_information_category code every one of these entries carries. A plan document
//requirement is an uploaded document, and "attachment" is the code the standalone pre-auth documents
//screen (hie_insurance_preAuth_documents) defaults its own category_code dropdown to for exactly that.
const DOCUMENT_CATEGORY_CODE = "attachment";

const MANDATORY_QUESTIONNAIRE_TEXTS = [
  "https://payer.gov.in/policy/questionnaire/100024"
];

//Questionnaires that do not apply once an implant or unspecified package is on the request: while any package
//row has implantApplicable "Y" or unspecified "Y" they are not asked at all, whatever the biometric route.
const IMPLANT_EXCLUDED_QUESTIONNAIRE_TEXTS = [
  "https://payer.gov.in/policy/questionnaire/106329"
];

@Component({
  selector: 'app-nhcx-authorization',
  templateUrl: './nhcx-authorization.component.html',
  standalone: false
})
export class NhcxAuthorizationComponent extends UiEngineComponent {
  //every HTTP call this screen makes is registered here so a destroy that lands before the
  //response cancels it. A container rather than takeUntil(destroy$) on purpose: the
  //questionnaire/document calls are opened inside the getById callback, and add() on an
  //already-closed Subscription unsubscribes the child immediately - takeUntil would not,
  //because it only reacts to next(), never to a notifier that has already completed.
  private subscriptions = new Subscription();
  tabChange: boolean = false;
  scheme_id: any;
  ip_banner: any;
  file_arg: any; disbledTimePickerRange: any = {};
  actTab: any;
  tabClick: boolean = false;
  viewCount: boolean = false;
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  showPopUp: boolean = true;
  resourceDef: any = false;
  sidebarOpen: any;
  locale = {
    "format": "DD/MM/YYYY HH:mm"
  }
  serviceItemRequired: boolean = true;
  to: any;
  config: any;
  age: number;
  bannerData: any;
  showBanner: boolean = false
  greaterage: number;
  lessage: number;
  from_date: string;
  care_type: any = "";
  serviceList: any = []
  serviceItemList: any = [];
  limit = 10;
  page = 0;
  pageSize = 10;
  itemsCount: any;
  services: any = [];
  searchKey: any = '';
  serviceType: any = '';
  serviceItemId: any;
  serviceDate: any;
  resourceDef1: any;
  operator: any;
  btn: any;
  questionairreRequired: boolean = false;
  stgquestionairreRequired: boolean = false;
  documentRequired: boolean = false;
  questionairreAdded: boolean = false;
  documentAdded: boolean = false;
  package_total_amount: any = 0;
  cardData: any = "";
  dec_p: any;
  f_type: any;
  //payer payload rows: the keys vary by payer and by which of the two shapes the caller sent (see
  //questionnaireSources / documentSources), so the value type stays open - what these annotations
  //pin down is that all three hold arrays.
  questionairreData: Record<string, any>[];
  stgquestionairreData: Record<string, any>[];
  documentData: Record<string, any>[];
  formAction: string = 'ADD';
  isView: boolean = false;
  pageTitleKey: string = 'pagename.add.nhcx_authorization';
  formData: Record<string, any> | null = null;//record handed to dhs-form so the static blocks auto-fill in VIEW
  //enhancement only: what the plan returned for each package added through the composite array, keyed
  //by benefitCode as {benefitName, questionnaires, stgQuestionnaires}, so both generated sections can
  //show that package's questions and onSaveFinished can hang both lists off the right row.
  packageQuestionnaires: any = {};
  //enhancement only: whether the package the authorization was approved for is still on the array. Its
  //questionnaire, STG questionnaire and documents come off the record, so they hold only while it does.
  recordPackagePresent: boolean = true;
  //enhancement only: the package set the generated sections currently on the form were built from, so a
  //sync can tell whether they still match the array - see generatedSectionsSignature.
  generatedSectionsBuiltFrom: string = "";
  //Where each rendered questionnaire and document was actually asked, so the payload can read it back out
  //of the one place it was answered. Two packages requiring the same thing are asked once - the first
  //package to claim it owns the controls - and every package that requires it reads that same answer.
  //Keyed by section name prefix then questionnaire identity; documents by requirement code.
  askedQuestionnairePrefix: any = {};
  askedDocumentPrefix: any = {};
  //the package array control currently being watched, and the watch on it - see watchPackageRows
  private packageRowsControl: any;
  private packageRowsSub: Subscription;
  //Controls whose name changed in the rebuild about to happen, as {container, oldKey, newKey}. A
  //questionnaire or document required by several packages is asked once, by whichever package claims it;
  //delete or edit that package and the next one claims it, which renames its controls. Without carrying
  //the answers across, the section would survive the delete - correctly, the remaining package still
  //requires it - but come back blank.
  private pendingControlRenames: any[] = [];
  //guards the watch against the rebuild it triggers: patchValue writes the array back, which would
  //otherwise re-enter the sync from inside itself
  private syncingPackageSections: boolean = false;
  //result keys the payload has consumed. They are removed only once every package has read them: a shared
  //uploader is read by more than one package, and deleting on first read left the rest with nothing.
  consumedResultKeys: any = {};
  //Whether "without biometric" is ticked. The mandatory questionnaires are the patient consent route, the
  //alternative to biometric clearance, so they are shown only while that route is the one being taken.
  withoutBiometric: boolean = false;
  //Generated questionnaire block name -> whether it is one of the mandatory questionnaires, so the
  //checkbox can show or hide exactly those blocks on the built form without regenerating it.
  biometricGatedBlocks: any = {};
  //Generated questionnaire block name -> whether it is one of the questionnaires an implant or unspecified
  //package excludes. Whether it is excluded right now is read off the package rows each time, since they change.
  packageExcludableBlocks: any = {};
  //the title each uploader was defaulted to when its file was picked, keyed by the title control. A
  //title still holding what was filled in here is a default and is refreshed when another file is
  //uploaded over it; anything else is the provider's own wording and is left alone.
  autoFilledTitles: any = {};
  //the file last picked for each uploader, keyed by the uploader's own control. It is only a name until
  //the upload lands - see watchTitledUploaders - and an uploader whose pick never went up has none.
  private pickedFileNames: any = {};
  //the uploader controls being watched, keyed the same way, as {control, sub}. A rebuild replaces every
  //control on the form, so the watch has to move with it.
  private uploaderWatches: any = {};
  configApproval = {
    "customButtonsAllowed": false,
    "allowPagination": false,
    "allowConfigGrid": false,
    "hideSearchBox": true,
    "help": false
  }
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public asideBarService: AsideBarService,
    public sessionStorage: StorageService,
    public loader: LoaderService
  ) {
    super(injector, router, route, modal)
    //the same component drives ADD (authorization request), the enhanced/query resubmission forms
    //and VIEW - the action comes from the route so nothing here is hardcoded per screen.
    this.isView = route.snapshot.data != undefined && route.snapshot.data['action'] == 'VIEW';
    this.pageTitleKey = this.isView ? 'pagename.view.nhcx_authorization' : 'pagename.add.nhcx_authorization';
    this.communicationService.emitSidebar({ sidebar: true });
    this.config = {
      "submitButton": !this.isView,
      "cancelButton": false,
      "filterForm": false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.btn = {
      "Add": [
        {
          "label": "button.submit",
          "icon": "fa fa-check"
        }
      ]
    };
    // this.router.events.subscribe((e: any) => {
    //   if (e instanceof NavigationEnd) {
    //     this.ngOnInit();
    //   }
    // });
  }

  /**
   * Nothing in this component dismisses the spinner on its own - dhs-form's ngOnInit is what hides it,
   * and that only runs once a resourceDef has been built. A failed fetch never gets that far, so
   * without this the page stays blocked behind the spinner with nothing said.
   * The toast fires once per open: a plan outage fails all three of the parallel fetches below, and
   * three identical messages help nobody. Every failure is still logged and still hides the spinner.
   */
  private loadFailureReported: boolean = false;

  private reportLoadFailure(context: string, err: any, message: string): void {
    this.loader.hideSpinner();
    console.error(context + " failed:", err);
    if (this.loadFailureReported) {
      return;
    }
    this.loadFailureReported = true;
    // Prefer what the payer service actually said; err.message alone is Angular's raw
    // "Http failure response for ..." string, which is no help to the front desk.
    const serverMessage = typeof err?.error === "string" ? err.error : err?.error?.message;
    this.formService.alerts.error(serverMessage ? serverMessage : message);
  }

  ngOnInit() {
    this.loader.showSpinner()
    this.loadFailureReported = false;
    this.cardData = JSON.parse(sessionStorage.getItem('currentData'));
    if (this.formService.appService.getUniversalConfig('multi_care_type')) {
      this.care_type = this.appService.getDynamicFunctions("getCurrentCareType")
    }
    let fields = []
    let result = {}
    let stgresult = {}
    let documentReaource = {}
    this.getCardData();
    this.subscriptions.add(
      this.formService.baseService.getById(this.formService.route.snapshot.queryParams.key, "preAuthorization_requests", "insurance").subscribe(element => {
        if (element && element['item_details'] && element['item_details'].length > 0) {
          this.cardData = element;
          this.withoutBiometric = element['without_biometric'] == true;
          if (this.isView) {
            //form.service fills each control from the dhs-form [data] input, matched by field name.
            //without this only the few controls the decorator sets explicitly are populated.
            this.formData = element;
          }
            if(this.cardData['item_details'] != undefined && this.cardData['item_details'].length > 0 && (this.isView || this.requestType == "resubmit" || this.requestType == "query" || this.isEnhancement)){
            this.questionairreData = this.cardData['item_details'][0]['questionnaireList']
            this.stgquestionairreData = this.cardData['item_details'][0]['stgQuestionnaireList']
            this.documentData = this.cardData['item_details'][0]['documentList']
            //A record can hold either resolved lists (questionnaire title + items, document display + the
            //saved answers) or just the plan refs. Resubmission and view assume the former; an enhancement
            //opened on a record that carries only refs would build no sections at all, so those are
            //resolved the way the fresh-preauth path does before the form is built. Lists that are already
            //resolved are left alone - re-fetching them would drop the answers stored on the record.
            //Every package is offered to the resolver, not just row 0: the second package of a two-package
            //request can be the only one still holding refs, and gating on row 0's lists is what left it
            //with no questionnaire and no uploaders. A record that needs nothing resolved raises no call -
            //resolveRecordLists builds the form straight away.
            if (this.isEnhancement) {
              this.resolveRecordLists();
            }
            else {
              this.enhancedPopulateForm();
            }
          }
          else{
            if (this.cardData['item_details'][0]['questionnaireList'] && this.cardData['item_details'][0]['questionnaireList'].length > 0) {
            this.questionairreRequired = true
            result = {
              'questionnaireList': this.cardData['item_details'][0]['questionnaireList'],
              'policyCode': this.cardData['policyNumber'],
              'recipientCode': this.cardData['payerCode']
            }
            stgresult = {
              'questionnaireList': this.cardData['item_details'][0]['stgQuestionnaireList'],
              'policyCode': this.cardData['policyNumber'],
              'recipientCode': this.cardData['payerCode']
            }
            this.loader.showSpinner()
            this.subscriptions.add(
              this.formService.baseService.action(result, "GET_QUESTIONNAIRE_LIST", "insurance", "nhcx_plan_questionnaire").subscribe((data1) => {
                if (data1 && data1.resource && data1.resource.length > 0) {
                  this.questionairreData = data1.resource
                  this.questionairreRequired = false
                  if (this.cardData['item_details'][0]['documentList'] && this.cardData['item_details'][0]['documentList'].length > 0) {
                    if(this.documentData == undefined){
                      this.documentRequired = true
                    }
                    else{
                      this.documentRequired = false
                    }
                  }
                  if (this.cardData['item_details'][0]['stgQuestionnaireList'] && this.cardData['item_details'][0]['stgQuestionnaireList'].length > 0) {
                    if(this.stgquestionairreData == undefined){
                      this.stgquestionairreRequired = true
                    }
                    else{
                      this.stgquestionairreRequired = false
                    }
                  }
                  this.populateForm();
                }
              }, (err: any) => {
                this.reportLoadFailure("GET_QUESTIONNAIRE_LIST", err, "Unable to load the questionnaire for this request.");
              })
            )
            this.loader.showSpinner()
            this.subscriptions.add(
              this.formService.baseService.action(stgresult, "GET_QUESTIONNAIRE_LIST", "insurance", "nhcx_plan_questionnaire").subscribe((stgdata) => {
                if (stgdata && stgdata.resource && stgdata.resource.length > 0) {
                  this.stgquestionairreData = stgdata.resource
                  this.stgquestionairreRequired = false
                  if (this.cardData['item_details'][0]['questionnaireList'] && this.cardData['item_details'][0]['questionnaireList'].length > 0) {
                    if(this.questionairreData == undefined){
                      this.questionairreRequired = true
                    }
                    else{
                      this.questionairreRequired = false
                    }
                  }
                  if (this.cardData['item_details'][0]['documentList'] && this.cardData['item_details'][0]['documentList'].length > 0) {
                    if(this.documentData == undefined){
                      this.documentRequired = true
                    }
                    else{
                      this.documentRequired = false
                    }
                  }
                  this.populateForm();
                }
              }, (err: any) => {
                this.reportLoadFailure("GET_QUESTIONNAIRE_LIST (STG)", err, "Unable to load the STG questionnaire for this request.");
              })
            )
          }

          if (this.cardData['item_details'][0]['documentList'] && this.cardData['item_details'][0]['documentList'].length > 0) {
            this.documentRequired = true
            documentReaource = {
              'documentList': this.cardData['item_details'][0]['documentList'],
              'policyCode': this.cardData['policyNumber'],
              'recipientCode': this.cardData['payerCode'],
              'categoryCode': this.cardData['item_details'][0]['category'],
              'benefitCode': this.cardData['item_details'][0]['service_code']
            }
            this.loader.showSpinner()
            this.subscriptions.add(
              this.formService.baseService.action(documentReaource, "GET_DOC_REQUIREMENT_LIST", "insurance", "nhcx_plan_doc_requirement").subscribe((data1) => {
                if (data1 && data1.resource && data1.resource.length > 0) {
                  this.documentData = data1.resource
                  this.documentRequired = false
                  if (this.cardData['item_details'][0]['stgQuestionnaireList'] && this.cardData['item_details'][0]['stgQuestionnaireList'].length > 0) {
                    if(this.stgquestionairreData == undefined){
                      this.stgquestionairreRequired = true
                    }
                    else{
                      this.stgquestionairreRequired = false
                    }
                  }
                  if (this.cardData['item_details'][0]['questionnaireList'] && this.cardData['item_details'][0]['questionnaireList'].length > 0) {
                    if(this.questionairreData == undefined){
                      this.questionairreRequired = true
                    }
                    else{
                      this.questionairreRequired = false
                    }
                  }
                  this.populateForm();
                }
              }, (err: any) => {
                this.reportLoadFailure("GET_DOC_REQUIREMENT_LIST", err, "Unable to load the document list for this request.");
              })
            )
          }
          }
          //VIEW reads the answers already stored on the record, exactly like enhanced/query do - it must
          //not re-fetch the plan masters, otherwise the saved questionnaire/document values are lost.
        }
        else{
            let resource = 'nhcx_authorization_request'
    this.baseService.getResourceDef(resource, (data) => {
      console.log("value is :: ", data);
      this.resourceDef = data;
      this.resourceDef['form']['bannerJson'] = this.bannerData
      this.sessionStorage.setCurrentResource('nhcx_authorization_request');
    });
    this.dec_p=this.baseService.initDecorator("nhcxAuthorizationDecorator", this.route, this.injector);
          }
      }, (err: any) => {
        //the request itself could not be read, so no form is ever built - this is the one failure that
        //leaves the screen with nothing on it at all
        this.reportLoadFailure("preAuthorization_requests getById", err, "Unable to open the authorization request. Please try again.");
      })
    )
    // this.bannerData['key'] = cardData

  }

  enhancedPopulateForm() {
    let resource = ""
    this.loader.showSpinner()
    if (this.questionairreRequired == false && this.documentRequired == false && this.stgquestionairreRequired == false) {
      this.loader.showSpinner()
      if(this.formService.route.snapshot.queryParams.type == "resubmit"){
        resource = "nhcx_authorization_resubmit"
      }
      else if(this.formService.route.snapshot.queryParams.type == "query"){
        resource = 'nhcx_authorization_query'
      }
      else if(this.formService.route.snapshot.queryParams.type == "direct"){
        resource = 'nhcx_authorization_request'
      }
      else if(this.isEnhancement){
        resource = 'nhcx_authorization_enhancement'
      }
      else if(this.isView){
        resource = this.route.snapshot.data != undefined && this.route.snapshot.data['resource'] ? this.route.snapshot.data['resource'] : 'nhcx_authorization_request'
      }
      this.baseService.getResourceDef(resource, (data) => {
        this.loader.showSpinner()
        console.log("value is :: ", data);
        this.resourceDef = data;
        //Questionnaire, STG questionnaire and document list are generated off the record instead of
        //being declared in the screen JSON, so each has to stand on its own: an authorization carrying
        //a questionnaire but no STG list (or the reverse) must still render what it does have. A single
        //shared gate plus an unguarded stgquestionairreData.forEach used to throw on a record with no
        //stgQuestionnaireList, which aborted this callback and took the document list down with it.
        //every package already on the request contributes its own blocks below, exactly as one added to
        //the array would - so this has to run before the sections are built from it
        this.seedPackagesFromRecord();
        const sections = this.questionnaireSectionDefinitions();
        const questionnaireBlocks: any[] = this.buildSectionBlocks(sections[0]);
        const stgquestionnaireBlocks: any[] = this.buildSectionBlocks(sections[1]);
        if (questionnaireBlocks.length > 0 || stgquestionnaireBlocks.length > 0) {
          this.loader.showSpinner()
          // child resource
          let questionnaireResource = {
            resource: this.questionnaireDefName(),
            form: {
              blocks: questionnaireBlocks
            },
            list: {
              fields: []
            },
          };
          let stgquestionnaireResource = {
            resource: this.stgQuestionnaireDefName(),
            form: {
              blocks: stgquestionnaireBlocks
            },
            list: {
              fields: []
            },
          };
          console.log("STG QUESTIONNAIRE RESOURCE", JSON.stringify(questionnaireResource));
          this.formService.baseService.saveJsonDef(this.stgQuestionnaireDefName(), stgquestionnaireResource);
          this.formService.baseService.saveJsonDef(this.questionnaireDefName(), questionnaireResource);

          // Parent block
          const questionnaireOrder = this.requestType == "direct" ? 7 : 6;
          this.placeBlock(this.compositeQuestionnaireBlock("questionnaire", "Questionnaire", this.questionnaireDefName(), questionnaireOrder, this.anyBlockVisible(questionnaireBlocks)));
          this.placeBlock(this.compositeQuestionnaireBlock("stg_questionnaire", "STG Questionnaire", this.stgQuestionnaireDefName(), questionnaireOrder + 1, this.anyBlockVisible(stgquestionnaireBlocks)));
          this.resourceDef.form.loaded = true;
          this.baseService.getReferredField(this.resourceDef.form, (response) => {
            this.config.fromConfig = {
              "submitButton": !this.isView,
              "cancelButton": false,
              "delegateSave": true,
            }
            this.resourceDef.form['blocks'] = response;
            this.applyViewMode();//this callback replaces blocks, so re-apply the read-only flags
          });
        }


        //what the sections below are built from, so the first array event can tell whether they still
        //match it - the record's package is on the form until the array says otherwise
        this.generatedSectionsBuiltFrom = this.generatedSectionsSignature();
        //the uploaders are generated the same way the questions are, and from the same state, so the
        //block can be rebuilt when a package is added or removed instead of only being shown or hidden.
        const documentFields = this.buildDocumentFields();
        if (documentFields.length > 0) {
          this.loader.showSpinner()
          this.placeBlock(this.documentBlock(documentFields, this.requestType == "direct" ? 9 : 8));
        }
        this.applyViewMode();
        this.resourceDef['form']['bannerJson'] = this.bannerData
        this.sessionStorage.setCurrentResource(resource);
        this.watchPackageRows();
      })
      this.dec_p = this.baseService.initDecorator("nhcxAuthorizationDecorator", this.route, this.injector);
      super.ngOnInit();
    }
  }

  populateForm() {
    let fields = []
    let result = {}
    let formFields = {}
    this.loader.showSpinner()
    if (this.questionairreRequired == false && this.documentRequired == false && this.stgquestionairreRequired == false) {
      this.loader.showSpinner()
      let resource = 'nhcx_authorization_request'
      this.baseService.getResourceDef(resource, (data) => {
        this.loader.showSpinner()
        console.log("value is :: ", data);
        this.resourceDef = data;
        if (this.questionairreData && this.questionairreData.length > 0 && this.questionairreData[0].questionnaireList && Array.isArray(this.questionairreData[0].questionnaireList)) {
          let questionnaireBlocks: any[] = [];
          let stgquestionnaireBlocks: any[] = [];
          this.loader.showSpinner()
          this.questionairreData[0].questionnaireList.forEach((questionnaire, index) => {
          this.loader.showSpinner()
            let items = [];
            // support different API response formats
            if (questionnaire.items && Array.isArray(questionnaire.items)) {
              items = questionnaire.items;
            }
            questionnaireBlocks.push({
              name: `questionnaire_${index + 1}`,
              group_type: "blocks",
              visible: this.questionnaireBlockVisible(`questionnaire_${index + 1}`, questionnaire),
              fields: this.generateFields(items,"question"),
              title: questionnaire.title
            });
          });
          this.loader.showSpinner()
          this.stgquestionairreData[0].questionnaireList.forEach((stgquestionnaire, index) => {
            let items = [];
            // support different API response formats
            if (stgquestionnaire.items && Array.isArray(stgquestionnaire.items)) {
              items = stgquestionnaire.items;
            }
            stgquestionnaireBlocks.push({
              name: `stgquestionnaire_${index + 1}`,
              group_type: "blocks",
              visible: this.questionnaireBlockVisible(`stgquestionnaire_${index + 1}`, stgquestionnaire),
              fields: this.generateFields(items,"stg"),
              title: stgquestionnaire.title
            });
          });
          // child resource
          let questionnaireResource = {
            resource: this.questionnaireDefName(),
            form: {
              blocks: questionnaireBlocks
            },
            list: {
              fields: []
            },
          };
          let stgquestionnaireResource = {
            resource: this.stgQuestionnaireDefName(),
            form: {
              blocks: stgquestionnaireBlocks
            },
            list: {
              fields: []
            },
          };
          console.log("STG QUESTIONNAIRE RESOURCE", JSON.stringify(questionnaireResource));
          this.formService.baseService.saveJsonDef(this.stgQuestionnaireDefName(), stgquestionnaireResource);
          this.formService.baseService.saveJsonDef(this.questionnaireDefName(), questionnaireResource);

          // Parent block
          if(this.requestType == "direct"){
            this.resourceDef.form.blocks[7] = this.compositeQuestionnaireBlock("questionnaire", "Questionnaire", this.questionnaireDefName(), 7, this.anyBlockVisible(questionnaireBlocks));
            this.resourceDef.form.blocks[8] = this.compositeQuestionnaireBlock("stg_questionnaire", "STG Questionnaire", this.stgQuestionnaireDefName(), 8, this.anyBlockVisible(stgquestionnaireBlocks));
          }
          else{
            this.resourceDef.form.blocks[6] = this.compositeQuestionnaireBlock("questionnaire", "Questionnaire", this.questionnaireDefName(), 6, this.anyBlockVisible(questionnaireBlocks));
            this.resourceDef.form.blocks[7] = this.compositeQuestionnaireBlock("stg_questionnaire", "STG Questionnaire", this.stgQuestionnaireDefName(), 7, this.anyBlockVisible(stgquestionnaireBlocks));
          }
          this.resourceDef.form.loaded = true;
          this.baseService.getReferredField(this.resourceDef.form, (response) => {
            this.config.fromConfig = {
              "submitButton": !this.isView,
              "cancelButton": false,
              "delegateSave": true,
            }
            this.resourceDef.form['blocks'] = response;
            this.applyViewMode();//this callback replaces blocks, so re-apply the read-only flags
          });
        }


        if (this.documentData && this.documentData.length > 0) {
          let order = 0
          let sequence = 0
          fields = []
          this.loader.showSpinner()
          this.documentData[0].documentList.forEach(element => {
            order = order + 1
            formFields = {
              "label": element.display,
              "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
              "order": order,
              "type": "String",
              "component": "fileuploader",
              "resource": "orgImage",
              "multiple": false,
              "formatsAllowed": ".jpg,,.jpeg,.png,.Png,.pdf,.odt,.doc",
              "maxSize": 5,
              "name": element.code,
              "value": element.text,//without this an already uploaded document renders blank
              "disabled": this.isView
            }
            fields.push(formFields)
            order = order + 1
            fields.push(this.documentTitleField(element, "", order))
          });
          if(this.requestType == "direct"){
            this['resourceDef']['form']['blocks'][9] = {
              fields: fields,
              group_type: "accordian",
              name: "document_list",
              order: 7,
              title: "Document List"
            }
          }
          else{
            this['resourceDef']['form']['blocks'][8] ={
            fields: fields,
            group_type: "accordian",
            name: "document_list",
            order: 8,
            title: "Document List"
          }
        }
        }
        this.applyViewMode();
        this.resourceDef['form']['bannerJson'] = this.bannerData
        this.sessionStorage.setCurrentResource('nhcx_authorization_request');
      })
      this.dec_p = this.baseService.initDecorator("nhcxAuthorizationDecorator", this.route, this.injector);
      super.ngOnInit();
    }
  }
  getQuestionnaireValue(data: any, linkId: string, title?: any): any {
    while (data) {
      if (Object.prototype.hasOwnProperty.call(data, linkId)) {
        return data[linkId];
      }

      data = data.questionnaire;
    }

    return '';
  }

  getstgQuestionnaireValue(data: any, linkId: string): any {
    while (data) {
      if (Object.prototype.hasOwnProperty.call(data, linkId)) {
        return data[linkId];
      }

      data = data.stg_questionnaire;
    }

    return '';
  }


  //the form still runs as ADD so the searchselects load normally and their populate_field dependents
  //fire - read-only is applied per field here, mirroring how nhcx_enhanced_authorization_request.json
  //hardcodes "disabled": true on every field. group_type is left untouched so all sections render alike.
  applyViewMode() {
    if (!this.isView || !this.resourceDef || !this.resourceDef.form || !this.resourceDef.form.blocks) {
      return;
    }
    this.resourceDef.form.blocks.forEach((block: any) => {
      if (block && block.fields && Array.isArray(block.fields)) {
        block.fields.forEach((field: any) => {
          if (field) {
            field.disabled = true;
            field.required = false;//a disabled read-only form must never block on validation
            //a COMPOSITE-ARRAY renders its read-only dhs-data-grid on either action VIEW or view_mode.
            //we run as ADD, so set the flag - it also hides the add button and the inline flat form.
            if (field.type == 'COMPOSITE-ARRAY') {
              field.view_mode = true;
            }
          }
        });
      }
    });
  }

  //the generated blocks are registered globally by name, so VIEW uses its own pair of names -
  //otherwise opening a view would overwrite the definition an open add/resubmission form is bound to.
  questionnaireDefName(): string {
    return this.isView ? "configure_uiengine_fields_questionnaire_view" : "configure_uiengine_fields_questionnaire";
  }

  stgQuestionnaireDefName(): string {
    return this.isView ? "configure_uiengine_fields_stg_questionnaire_view" : "configure_uiengine_fields_stg_questionnaire";
  }

  //enhanced, query, enhancement and view all populate from the record instead of the plan masters -
  //the route's type param is the only thing that separates them.
  get requestType(): string {
    return this.formService.route.snapshot.queryParams.type;
  }

  //an enhancement adds packages to an already-approved authorization, so its package block is a
  //composite array (nhcx_package_details) rather than the single flat package the other flows use.
  get isEnhancement(): boolean {
    return true;
  }

  //A package has something to ask the plan about as soon as it carries a list - resolved or not. The
  //list is sent as the payload either way, which is how the record's package has always been read:
  //GET_QUESTIONNAIRE_LIST / GET_DOC_REQUIREMENT_LIST are the single source of what is asked and what
  //must be uploaded, so every package goes through them rather than rendering off whatever the record
  //happened to store.
  hasListToResolve(data: any): boolean {
    return Array.isArray(data) && data.length > 0;
  }

  //Every package's lists are resolved before the form is built, so the generated sections are assembled
  //once with everything in hand rather than rendering and then rebuilding underneath the provider.
  //Every list is read back from GET_QUESTIONNAIRE_LIST / GET_DOC_REQUIREMENT_LIST, whatever shape the
  //record stored it in - the plan is the authority on what a package asks and what it needs uploaded,
  //and what the record holds is only what was submitted last time. Resolving only row 0 is what left a
  //second package with nothing that could be built into a block, and so with no questionnaire and no
  //uploaders on screen.
  //Each task is handed the same `done`, and the counter is sized before any of them runs, so a package
  //with no list at all can answer synchronously without tripping the form build early.
  resolveRecordLists() {
    const rows = Array.isArray(this.cardData['item_details']) ? this.cardData['item_details'] : [];
    const tasks: any[] = [];
    const procedure = rows[0];
    //row 0 is the approved package, and the whole screen is built from the three record lists it fills
    if (procedure) {
      tasks.push((done: any) => this.resolveRecordQuestionnaire(procedure['questionnaireList'], (resolved: any[]) => {
        this.questionairreData = resolved;
      }, done));
      tasks.push((done: any) => this.resolveRecordQuestionnaire(procedure['stgQuestionnaireList'], (resolved: any[]) => {
        this.stgquestionairreData = resolved;
      }, done));
      tasks.push((done: any) => this.resolveRecordDocument(procedure, (resolved: any[]) => {
        this.documentData = resolved;
      }, done));
    }
    //every further package the request arrived with resolves into its own entry, which is what the
    //generated sections and the payload read it back out of
    rows.forEach((row: any, index: number) => {
      const benefitCode = this.rowBenefitCode(row);
      if (index == 0 || !benefitCode || this.isRecordPackage(benefitCode)) {
        return;
      }
      const entry = this.packageEntry(row);
      tasks.push((done: any) => this.resolveRecordQuestionnaire(row['questionnaireList'], (resolved: any[]) => {
        entry.questionnaires = resolved;
      }, done));
      tasks.push((done: any) => this.resolveRecordQuestionnaire(row['stgQuestionnaireList'], (resolved: any[]) => {
        entry.stgQuestionnaires = resolved;
      }, done));
      tasks.push((done: any) => this.resolveRecordDocument(row, (resolved: any[]) => {
        entry.documents = resolved;
      }, done));
    });
    let pending = tasks.length;
    if (pending == 0) {
      this.enhancedPopulateForm();
      return;
    }
    const done = () => {
      pending--;
      if (pending == 0) {
        this.enhancedPopulateForm();
      }
    };
    tasks.forEach((task: any) => task(done));
  }

  //The documents are read the same way the fresh-preauth path reads them: the record carries the plan's
  //refs and nhcx_plan_doc_requirement turns them into the requirements to upload against
  //({code, display, text}). That call used to live in the fresh-preauth branch of ngOnInit, which no
  //longer runs, so the uploaders were being built straight off the refs - with no display to label them.
  resolveRecordDocument(procedure: any, apply: any, done: any) {
    if (!this.hasListToResolve(procedure ? procedure['documentList'] : undefined)) {
      done();//the package has nothing to be supported by, so there is nothing to ask the plan for
      return;
    }
    const payload = {
      'documentList': procedure['documentList'],
      'policyCode': this.cardData['policyNumber'],
      'recipientCode': this.cardData['payerCode'],
      'categoryCode': this.rowCategoryCode(procedure),
      //the row being resolved, not always the approved package - a second package's requirements are
      //its own
      'benefitCode': this.rowBenefitCode(procedure)
    };
    this.loader.showSpinner();
    this.subscriptions.add(
      this.formService.baseService.action(payload, "GET_DOC_REQUIREMENT_LIST", "insurance", "nhcx_plan_doc_requirement").subscribe(
        (data: any) => {
          this.loader.hideSpinner();
          const resolved = this.documentSources(data ? data.resource : undefined);
          if (resolved.length > 0) {
            this.restoreDocumentUploads(procedure['documentList'], resolved);
            apply(resolved);
          }
          done();
        },
        (err: any) => {
          this.loader.hideSpinner();
          console.error("GET_DOC_REQUIREMENT_LIST failed while opening the request:", err);
          done();//the rest of the form still has to render
        })
    );
  }

  resolveRecordQuestionnaire(questionnaireList: any, apply: any, done: any) {
    if (!this.hasListToResolve(questionnaireList)) {
      done();//the package simply asks nothing of this kind, so there is nothing to ask the plan for
      return;
    }
    const payload = {
      'questionnaireList': questionnaireList,
      'policyCode': this.cardData['policyNumber'],
      'recipientCode': this.cardData['payerCode']
    };
    this.loader.showSpinner();
    this.subscriptions.add(
      this.formService.baseService.action(payload, "GET_QUESTIONNAIRE_LIST", "insurance", "nhcx_plan_questionnaire").subscribe(
        (data: any) => {
          this.loader.hideSpinner();
          const resolved = this.questionnaireSources(data ? data.resource : undefined);
          if (resolved.length > 0) {
            this.restoreQuestionnaireAnswers(questionnaireList, resolved);
            apply(resolved);
          }
          done();
        },
        (err: any) => {
          this.loader.hideSpinner();
          console.error("GET_QUESTIONNAIRE_LIST failed while opening the enhancement:", err);
          done();//the rest of the form still has to render
        })
    );
  }

  //GET_QUESTIONNAIRE_LIST answers with the questionnaire as the plan defines it, so every item comes
  //back carrying the plan's blank value whatever the record it was resolved from holds. The plan is the
  //authority on what is asked, the record on what was answered - so the saved answers are carried back
  //onto the items the plan returned. Without this every generated control rendered empty on view,
  //resubmission and query: a choice fell back to "Select", a textbox and a date to blank.
  //Matched by the questionnaire the answer belongs to and then by the item's own linkId. A questionnaire
  //the plan now returns under a different title still answers through the package-wide fallback: one
  //resolve only ever covers one package, and a linkId is unique inside it.
  restoreQuestionnaireAnswers(saved: any, resolved: any[]): void {
    const savedSources = this.questionnaireSources(saved);
    if (savedSources.length == 0) {
      return;//the record carried only the plan's refs - nothing was ever answered on it
    }
    const byIdentity: any = {};
    const byLinkId: any = {};
    savedSources.forEach((questionnaire: any) => {
      const items: any = {};
      questionnaire.items.forEach((item: any) => {
        if (!item || !item.linkId) {
          return;
        }
        items[item.linkId] = item;
        byLinkId[item.linkId] = item;
      });
      byIdentity[this.questionnaireIdentity(questionnaire)] = items;
    });
    resolved.forEach((questionnaire: any) => {
      const items = byIdentity[this.questionnaireIdentity(questionnaire)];
      questionnaire.items.forEach((item: any) => {
        if (!item || !item.linkId) {
          return;
        }
        const answered = items && items[item.linkId] ? items[item.linkId] : byLinkId[item.linkId];
        if (!answered) {
          return;//the plan asks something the record was never asked, so it stands unanswered
        }
        item.value = this.isAnswered(answered.value) ? answered.value : "";
        //an attachment is answered as the stored document's id beside the title it was submitted under,
        //so both travel back or the uploader comes up with a file and no name for it
        item.document_title = answered.document_title ? answered.document_title : "";
      });
    });
  }

  //The uploads are lost the same way the answers are: GET_DOC_REQUIREMENT_LIST answers with what the
  //plan requires, so a document already uploaded came back with no value and its uploader rendered
  //blank. The requirement stays the plan's and the upload stays the record's, matched on the
  //requirement code the two identify it by.
  restoreDocumentUploads(saved: any, resolved: any[]): void {
    const savedSources = this.documentSources(saved);
    if (savedSources.length == 0) {
      return;//refs only - nothing has been uploaded against this package yet
    }
    const byCode: any = {};
    savedSources.forEach((element: any) => {
      byCode[element.code] = element;
    });
    resolved.forEach((element: any) => {
      const uploaded = byCode[element.code];
      if (!uploaded) {
        return;
      }
      element.value = this.isAnswered(uploaded.value) ? uploaded.value : "";
      element.document_title = uploaded.document_title ? uploaded.document_title : "";
    });
  }

  //Two shapes reach here. The record stores its questionnaires flat ({title, items}), which is what
  //enhancedPopulateForm has always read, while GET_QUESTIONNAIRE_LIST answers with a wrapper row
  //({id, policyCode, recipientCode, questionnaireList: [...]}) - the shape populateForm unwraps. Both
  //are flattened to the questionnaires that actually carry items; anything else would build an
  //accordion with no fields in it. A missing list is tolerated: that is a record with no STG (or no
  //questionnaire) at all.
  questionnaireSources(data: any): any[] {
    if (!Array.isArray(data)) {
      return [];
    }
    let sources: any[] = [];
    data.forEach(entry => {
      if (!entry) {
        return;
      }
      if (Array.isArray(entry.questionnaireList)) {
        sources = sources.concat(entry.questionnaireList);
      } else {
        sources.push(entry);
      }
    });
    return sources.filter(entry => entry && Array.isArray(entry.items) && entry.items.length > 0);
  }

  //The same two shapes reach here as reach questionnaireSources: the record stores its documents flat
  //({code, display, text}) while GET_DOC_REQUIREMENT_LIST answers with a wrapper row carrying
  //documentList - the shape populateForm unwraps. Only entries that name what to upload are kept: a ref
  //with no display would build an uploader with no label, which is what a record straight off
  //eligibility carries.
  documentSources(data: any): any[] {
    if (!Array.isArray(data)) {
      return [];
    }
    let sources: any[] = [];
    data.forEach(entry => {
      if (!entry) {
        return;
      }
      if (Array.isArray(entry.documentList)) {
        sources = sources.concat(entry.documentList);
      } else {
        sources.push(entry);
      }
    });
    return sources.filter(entry => entry && entry.code && entry.display);
  }

  //Generated questions become controls named by their linkId, so two packages asking the same question
  //would otherwise bind to one control and answer each other. Each package's questions are therefore
  //named under its own benefitCode, which is what lets the same questionnaire stand once per package
  //and be answered independently. The record's package keeps the bare linkIds the other flows use.
  questionnaireKeyPrefix(benefitCode: string): string {
    return benefitCode ? benefitCode + "__" : "";
  }

  //What makes a questionnaire the same questionnaire wherever it appears: the plan asks it under one
  //title, made up of questions it identifies by linkId, so two packages carrying that same title and the
  //same linkIds are carrying one questionnaire and are asked it once.
  questionnaireIdentity(questionnaire: any): string {
    const items = Array.isArray(questionnaire.items) ? questionnaire.items : [];
    return (questionnaire.title ? questionnaire.title : "") + "|" + items.map((item: any) => item.linkId).join(",");
  }

  //The packages a section is built from, in the order they claim what they share: the approved package
  //first, so anything it requires keeps the bare control names the resubmission and view flows answer
  //under, then every further package the request arrived with.
  sectionOwners(recordSources: any[], packageKey: string, perPackage: boolean, inheritSources: any[] = []): any[] {
    const owners: any[] = [];
    if (this.recordPackagePresent) {
      owners.push({ keyPrefix: "", sources: recordSources });
    }
    if (perPackage) {
      Object.keys(this.packageQuestionnaires).forEach(benefitCode => {
        const own = this.packageQuestionnaires[benefitCode][packageKey];
        owners.push({
          keyPrefix: this.questionnaireKeyPrefix(benefitCode),
          //A package carrying no list of its own is carrying the approved package's, the same way it
          //submits it - see packageOrRecordList. Rendering it is what keeps a shared questionnaire on
          //screen once the package that was asking it is deleted: the requirement does not leave with
          //that package, so the section must not either, and the next owner simply claims it.
          sources: Array.isArray(own) && own.length > 0 ? own : inheritSources,
          namePrefixSuffix: "_" + benefitCode
        });
      });
    }
    return owners;
  }

  buildQuestionnaireBlocks(sources: any[], namePrefix: string, type: string, keyPrefix: string = ""): any[] {
    return sources.map((questionnaire: any, index: number) => {
      const name = `${namePrefix}_${index + 1}`;
      return {
        name: name,
        group_type: "blocks",
        visible: this.questionnaireBlockVisible(name, questionnaire),
        fields: this.generateFields(questionnaire.items, type, keyPrefix),
        title: questionnaire.title
      };
    });
  }

  //The benefit the authorization was approved for. Its questions come off the record, so it must never
  //also be fetched as an added package - that is what renders the same package's questionnaire twice.
  //The record stores the code as service_code where the array rows call it benefitCode, so both are
  //accepted.
  recordPackageCode(): string {
    const procedure = this.cardData && this.cardData['item_details'] ? this.cardData['item_details'][0] : undefined;
    if (!procedure) {
      return "";
    }
    return procedure['benefitCode'] ? procedure['benefitCode'] : (procedure['service_code'] ? procedure['service_code'] : "");
  }

  isRecordPackage(benefitCode: string): boolean {
    const recordCode = this.recordPackageCode();
    return recordCode != "" && benefitCode == recordCode;
  }

  //A row of the package array never carries a benefitCode: nhcx_package_details populates the plan's
  //benefitCode into service_code and its display into serviceItemName, which is also how the record
  //stores the approved package. Reading row['benefitCode'] matched nothing, so every add, edit and
  //delete looked like an array with no packages on it - which pruned whatever had been fetched and
  //took the record's questionnaire, STG questionnaire and document sections down with it.
  rowBenefitCode(row: any): string {
    if (!row) {
      return "";
    }
    return row['benefitCode'] ? row['benefitCode'] : (row['service_code'] ? row['service_code'] : "");
  }

  rowBenefitName(row: any): string {
    if (!row) {
      return "";
    }
    return row['benefitName'] ? row['benefitName'] : (row['serviceItemName'] ? row['serviceItemName'] : "");
  }

  //the plan is asked per category and benefit; the array names the category categoryCode where the
  //record names it category
  rowCategoryCode(row: any): string {
    if (!row) {
      return "";
    }
    return row['categoryCode'] ? row['categoryCode'] : (row['category'] ? row['category'] : "");
  }

  //Where a generated block goes in blocks[]: over the one of that name if it is already there, on the end
  //if it is not. Never at a computed index. The screen JSONs do not agree on how many blocks they
  //declare - the enhancement, query and resubmit layouts have six, so writing to 6, 7 and 8 appended -
  //but nhcx_authorization_request has eight, and writing the questionnaire to index 7 landed it on top of
  //preAuthDocuments, dropping that block off the direct form entirely. Position in the array is not what
  //orders the form anyway; the block's own `order` is, and that is passed in unchanged.
  placeBlock(block: any): void {
    const blocks = this.resourceDef.form.blocks;
    const current = blocks.findIndex((existing: any) => existing && existing.name == block.name);
    if (current > -1) {
      blocks[current] = block;
    } else {
      blocks.push(block);
    }
  }

  //an empty section is kept in place but hidden rather than dropped: a section with nothing to ask this
  //time is still the same block, replaced where it already stands.
  compositeQuestionnaireBlock(name: string, title: string, defName: string, order: number, visible: boolean): any {
    return {
      name: name,
      order: order,
      visible: visible,
      group_type: "accordian",
      layout_type: "no-column",
      fields: [
        {
          class_name: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 fix",
          order: 1,
          type: "COMPOSITE-OBJECT",
          component: defName,
          name: name
        }
      ],
      title: title
    };
  }

  //Every package the request arrived with has its own documents to be supported by, so the block holds one
  //group of uploaders per package, labelled with the package once there is more than one. The approved
  //package's come off the record and stand only while it is still on the array; every other package's come
  //off its own item_details row. The approved package's uploaders keep their bare document codes - the
  //naming the resubmission and view flows already upload and submit under - while the rest are namespaced
  //by benefit code, so two packages asking for the same document are uploaded against separately instead
  //of overwriting one another. A package added on this enhancement asks for nothing and appears nowhere.
  buildDocumentFields(): any[] {
    const recordSources = this.documentSources(this.documentData);
    const owners = this.sectionOwners(this.recordPackagePresent ? recordSources : [], "documents", true, recordSources);
    owners.forEach((owner: any) => {
      owner.sources = this.documentSources(owner.sources);
    });
    //A requirement more than one package has to be supported by is uploaded against once, by the first
    //owner to reach it - the same document satisfies every package that requires it.
    const asked: any = {};
    owners.forEach((owner: any) => {
      owner.sources.forEach((element: any) => {
        if (asked[element.code] == undefined) {
          asked[element.code] = { keyPrefix: owner.keyPrefix };
        }
      });
    });
    this.askedDocumentPrefix = asked;
    //every uploader is labelled with the document it asks for, for the same reason the questionnaires are
    //headed with their own title alone
    let fields: any[] = [];
    const rendered: any = {};
    owners.forEach((owner: any) => {
      //once per requirement, whoever claimed it - a package listing the same code twice still uploads once
      const claimed = owner.sources.filter((element: any) => {
        if (rendered[element.code] || asked[element.code].keyPrefix != owner.keyPrefix) {
          return false;
        }
        rendered[element.code] = true;
        return true;
      });
      fields = fields.concat(this.documentFields(claimed, owner.keyPrefix));
    });
    fields.forEach((field: any, index: number) => {
      field.order = index + 1;
    });
    return fields;
  }

  documentFields(documents: any[], keyPrefix: string): any[] {
    const fields: any[] = [];
    documents.forEach((element: any) => {
      fields.push({
        "label": element.display,
        "class_name": "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
        "order": 1,
        "type": "String",
        "component": "fileuploader",
        "resource": "orgImage",
        "multiple": false,
        "formatsAllowed": ".jpg,,.jpeg,.png,.Png,.pdf,.odt,.doc",
        "maxSize": 5,
        "name": keyPrefix + element.code,
        "value": element.value,//without this an already uploaded document renders blank
        "disabled": this.isView
      });
      fields.push(this.documentTitleField(element, keyPrefix));
    });
    return fields;
  }

  //Each upload is submitted under a title. It is filled with the name of the file that was uploaded so
  //nothing has to be typed for the ordinary case, and stays an ordinary editable control so the provider
  //can name the document whatever the payer expects. The control sits beside its uploader and is named
  //off the same requirement code, so the two travel together through every flow.
  documentTitleKey(code: string, keyPrefix: string = ""): string {
    return keyPrefix + code + "__title";
  }

  documentTitleField(element: any, keyPrefix: string, order: number = 1): any {
    return this.titleField(this.documentTitleKey(element.code, keyPrefix), element.document_title,
      "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix", order);
  }

  //a questionnaire's attachment is titled the same way, laid out in the column width its questions are
  //asked in so the title sits beside the uploader it belongs to
  attachmentTitleField(item: any, keyPrefix: string): any {
    return this.titleField(this.documentTitleKey(item.linkId, keyPrefix), item.document_title,
      "col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix");
  }

  titleField(name: string, savedTitle: any, className: string, order: number = 1): any {
    const title = savedTitle ? savedTitle : "";
    return {
      "label": "Title",
      "class_name": className,
      "order": order,
      "type": "String",
      "component": "textbox",
      "name": name,
      //a textbox renders from default, VIEW renders from value - a saved title has to survive both
      "value": title,
      "default": title,
      "disabled": this.isView
    };
  }

  //The title of an upload is read back out of the control it was rendered into and lands on the
  //requirement itself. A requirement nothing was uploaded against carries no title either, so the two
  //never go out of step.
  documentTitleValue(result: any, element: any, keyPrefix: string, uploaded: boolean): string {
    const key = this.documentTitleKey(element.code, keyPrefix);
    const title = uploaded && result[key] != undefined ? result[key] : "";
    //the titles belong to the document list, not to the request's own fields - but a shared uploader's
    //title is read by every package that requires it, so it is dropped only once they all have
    this.consumedResultKeys[key] = true;
    return title;
  }

  //An attachment's title is answered into the same composite its uploader was rendered in, under the
  //control name it was rendered with, and lands on the item beside the value it titles. An item nothing
  //was uploaded against carries no title either, so the two never go out of step. Only an attachment is
  //titled - every other kind of question answers with the value alone.
  attachmentTitleValue(item: any, answers: any, stg: boolean, keyPrefix: string = "") {
    if (!item || item.itemType != "attachment") {
      return;
    }
    const key = this.documentTitleKey(item.linkId, keyPrefix);
    const title = stg
      ? this.getstgQuestionnaireValue(answers, key)
      : this.getQuestionnaireValue(answers, key);
    item.document_title = item.value && title ? title : "";
  }

  //The name of the file is only ever known to the uploader: what it writes to its control is the stored
  //document's id, and its change event carries neither. It does render its own file input though - and a
  //native change bubbles - so the file that was just picked is read straight off it. Every uploader on
  //the screen is caught this way, the documents and the two questionnaires' attachments alike, and an
  //uploader that names no title control is simply not one that is titled.
  @HostListener('change', ['$event'])
  onFilePicked(event: any) {
    const target = event ? event.target : undefined;
    if (!target || target.type != 'file') {
      return;
    }
    const files = target.files;
    if (!files || files.length == 0) {
      return;
    }
    const key = this.uploaderFieldKey(target);
    if (!key) {
      return;
    }
    //the file is only picked here, it has not been uploaded yet: an image is cropped first and goes up
    //when the Upload button is pressed, so the name is held until the upload actually lands
    this.pickedFileNames[key] = files[0].name;
    this.watchTitledUploaders();
  }

  //A title follows the document it titles: it is filled with the name of the file once the upload lands,
  //and cleared again when the document is deleted. Both are read off the uploader's own control rather
  //than off the page - the uploader writes the stored document's id to it when the upload returns and
  //blanks it on delete (file-uploader.component.ts set value), which a pick alone never does. So an
  //image the provider crops away, or a file swapped out before the Upload button is pressed, is never
  //titled. A titled uploader is recognised by name, a control with a <key>__title beside it, so the
  //documents and the two questionnaires' attachments are all watched and nothing else is touched.
  watchTitledUploaders() {
    const group = this.config.formGroup ? this.config.formGroup : (this.formComponenet ? this.formComponenet['form'] : undefined);
    const controls = group ? group.controls : undefined;
    if (!controls) {
      return;
    }
    Object.keys(controls).forEach((key: string) => {
      const titleKey = this.documentTitleKey(key);
      if (!controls[titleKey]) {
        return;//not an uploader, or one that is not titled
      }
      const watch = this.uploaderWatches[key];
      if (watch && watch.control == controls[key]) {
        return;//already watching this one
      }
      if (watch) {
        watch.sub.unsubscribe();//the control it was watching has been replaced by a rebuild
      }
      const sub = controls[key].valueChanges.subscribe((value: any) => this.titleDocument(key, titleKey, value));
      this.uploaderWatches[key] = { control: controls[key], sub: sub, uploaded: this.uploaded(controls[key].value) };
      this.subscriptions.add(sub);
    });
  }

  //A document that has just been deleted takes its title with it - the title named a document that is no
  //longer there, so it is cleared outright rather than left for the provider to notice. Only a document
  //that was actually there is cleared after, not every empty the control is written: a form rebuild
  //writes every control back, and a title saved with the request must survive that untouched. A file the
  //provider never picked here - a document the request was loaded with - keeps the title it was saved
  //under, and is not renamed by an upload it was not part of.
  titleDocument(key: string, titleKey: string, value: any) {
    const watch = this.uploaderWatches[key];
    const wasUploaded = watch ? watch.uploaded : false;
    const isUploaded = this.uploaded(value);
    if (watch) {
      watch.uploaded = isUploaded;
    }
    if (isUploaded) {
      if (this.pickedFileNames[key]) {
        this.defaultTitle(titleKey, this.pickedFileNames[key]);
      }
    } else if (wasUploaded) {
      this.clearTitle(key, titleKey);
    }
  }

  //an uploader holds the stored document's id, or the ids it holds, and nothing at all until one is
  //uploaded into it
  uploaded(value: any): boolean {
    return value != undefined && value != "" && value.length != 0;
  }

  clearTitle(key: string, titleKey: string) {
    const control = this.formControl(titleKey);
    delete this.pickedFileNames[key];
    delete this.autoFilledTitles[titleKey];
    if (control && control.value) {
      control.setValue("");
    }
  }

  //Which field the file was picked for cannot be read off the input itself: the uploader ids it sel<n>
  //for an n it generates at random (file-uploader.component.ts), not by field name - reading the id was
  //why nothing was ever filled in. What does carry the field name is the element the input is rendered
  //in: form-question stamps the question's own key on the <dhs-file-uploader> host, so the nearest one
  //above the input names the field that was uploaded into.
  uploaderFieldKey(target: any): string {
    const host = target.closest ? target.closest('dhs-file-uploader') : undefined;
    return host && host.id ? host.id : "";
  }

  //A title the provider has typed over is left as it is; one still holding what was filled in here is
  //refreshed when a different file is picked in its place.
  defaultTitle(key: string, fileName: string) {
    const control = this.formControl(key);
    if (!control) {
      return;//an uploader that is not titled
    }
    if (control.value && control.value != this.autoFilledTitles[key]) {
      return;//named by the provider
    }
    control.setValue(fileName);
    this.autoFilledTitles[key] = fileName;
  }

  //A composite's blocks are flattened into the one FormGroup the rest of the form is built into
  //(question-control.service.ts copies a nested block's controls onto the group it is nested in), so the
  //questionnaires' uploaders and titles are controls of the same group the documents' are. The form
  //component is asked for the group as well as config.formGroup: a rebuild replaces it, and
  //config.formGroup only catches up on the next getData.
  formControl(key: string): any {
    const groups = [this.config.formGroup, this.formComponenet ? this.formComponenet['form'] : undefined];
    for (const group of groups) {
      const controls = group ? group.controls : undefined;
      if (controls && controls[key]) {
        return controls[key];
      }
    }
    return undefined;
  }

  //an empty block is kept in place but hidden, for the same reason the generated questionnaire sections
  //are: blocks[] is indexed, so dropping one would leave a hole in it
  documentBlock(fields: any[], order: number): any {
    return {
      fields: fields,
      group_type: "accordian",
      name: "document_list",
      order: order,
      visible: fields.length > 0,
      title: "Document List"
    };
  }

  generateFields(items: any[],type:any,keyPrefix: string = ""): any[] {
    if (!items || !Array.isArray(items)) {
      return [];
    }

    let fields: any[] = [];
    this.loader.showSpinner()
    items.forEach((item, index) => {
      if (!item || !item.linkId) {
        return;
      }
      let field: any = {

        label: item.text,
        //the question keeps its linkId on the payload; only the control it is answered in is namespaced
        name: keyPrefix + item.linkId,
        order: index + 1,
        //dhs-form's VIEW action only relabels the save button, it does not lock the controls -
        //these fields are generated, so the read-only state has to be stamped on here.
        required: this.isView ? false : (type == "stg"? true : false),
        disabled: this.isView,
        class_name: "col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 fix"
      };
      const apiValue = item.value ? item.value : "";
      if (this.isView) {
        field.value = apiValue;//default is only applied on ADD, VIEW renders from value
        field.default = apiValue;
      }
        switch (item.itemType) {

        case "string":
          field.type = "String";
          field.component = "textbox";
          field.default = apiValue;
          break;

        case "choice":
          field.type = "String";
          field.component = "dropdown";
          let possibleValueForDropdown = []
          let selectedValue = ""
          item.answerOptions.forEach(element => {
            let possibleValues = {
              id: element.valueString,
              value: element.valueString
            }
            //initialSelected is the flag that marks the option, not the option itself - what the control
            //has to hold is the answer string the dropdown lists that option under, which is the same
            //valueString the possible_value is built from. Assigning the flag put `true` here, which
            //matches no option, so the plan's own default never came up selected.
            if (element.initialSelected) {
              selectedValue = element.valueString
            }
            possibleValueForDropdown.push(possibleValues)
          });
          field.datasource = {
            "possible_value": possibleValueForDropdown
          }
          //The provider's saved answer wins; the plan's initially-selected option only stands in where
          //nothing has been answered yet. VIEW is left alone either way - a read-only screen must show
          //what was actually answered, never an option the plan would have pre-selected.
          field.default = apiValue ? apiValue : (this.isView ? apiValue : selectedValue);
          break;

        case "dateTime":
          field.type = "date";
          field.component = "daterangepicker";
          field.singleDatePicker = true;
          field.timePicker = true;
          field.locale = {
            "format": "DD/MM/YYYY HH:mm"
          },
          field.timePickerSeconds = false
          field.default = apiValue;
          break;

        case "attachment":
              field.type = "String",
              field.component = "fileuploader",
              field.resource = "orgImage",
              field.multiple = false,
              field.formatsAllowed = ".jpg,,.jpeg,.png,.Png,.pdf,.odt,.doc",
              field.maxSize = 5,
              field.value = apiValue

          break;

        default:
          field.type = "String";
          field.component = "textbox";
      }
      fields.push(field);
      //an attachment is titled the same way a document requirement is: the uploader is followed by the
      //title it is submitted under, defaulted to the name of the file that was uploaded
      if (item.itemType == "attachment") {
        fields.push(this.attachmentTitleField(item, keyPrefix));
      }
    });
    //the titles are inserted between the questions, so the sort order is re-run over what was built
    //rather than left on the item's own index - two fields would otherwise share a position
    fields.forEach((field: any, index: number) => {
      field.order = index + 1;
    });

    console.log("QUESTIONNAIRE FIELDS", fields);
    return fields;
  }


  getCardData() {
    this.loader.showSpinner()
    if (this.showBanner == false) {
      if(this.formService?.route?.snapshot?.queryParams?.type == "enhancement"){
        this.bannerData = {
          "selector": "app-patient-layout",
          "datasource": {
            "application": "insurance",
            "resource": "preAuthorization_requests",
            "query_id": "GET_BY_ID_FOR_ENHANCEMET"
          },
          "jsonName": "nhcx_eligibility_banner"
        }
      }
      else{
        this.bannerData = {
        "selector": "app-patient-layout",
        "datasource": {
          "application": "insurance",
          "resource": "preAuthorization_requests",
          "query_id": "GET_BY_ID"
        },
        "jsonName": "nhcx_eligibility_banner"
      }
      }
      this.showBanner = true;
    }
  }

  ngAfterViewInit() {
    this.checkSidebarOpen();
  }
  getDataFn(event) {
    if (event.type == 'form') {
      this.config.formGroup = event.obj;
      this.watchTitledUploaders();//the generated uploaders only have controls once the form is built
    }
    if (event.type == 'mapping' && this.isView) {
      this.setFileUploadersReadOnly(event.obj);
      this.setFileUploadersReadOnly(this.formService.compositeQuestionMapping);
    }
  }

 
  //in the uploader, which also guards every delete icon, so the document just renders for download.
  setFileUploadersReadOnly(questionMapping: any) {
    if (!questionMapping) {
      return;
    }
    Object.keys(questionMapping).forEach(key => {
      let entry = questionMapping[key];
      if (!entry) {
        return;
      }
      if (entry.controlType == 'fileuploader') {
        entry['formAction'] = 'VIEW';
      } else if (typeof entry == 'object' && entry.controlType == undefined) {
        this.setFileUploadersReadOnly(entry);//composite mapping is keyed block -> field
      }
    });
  }
  onSaveFinished(e) {
    if(this.requestType == "query"){
      e.result['action_type'] = "Queried"
    }
    else if(this.requestType == "enhancement"){
      e.result['action_type'] = "enhancement"
      if(this.cardData.item_details?.length == e.result.item_details?.length && this.cardData.status != "Enhancement Eligibility Completed" && this.cardData.status != "Enhancement Eligibility Failed"){
        this.formService.alerts.error("You can not raise enhancement without adding any additional service");
        return;
      }
    }
    else if(this.requestType == "resubmit"){
      e.result['action_type'] = "resubmission"
    }
    if (this.isView) {
      return;//a view must never re-submit the authorization
    }
    const questionnaireData = e.result.questionnaire;
    const stgquestionnaireData = e.result.stg_questionnaire;
    //checked before the payload is assembled, so an incomplete request is stopped here rather than being
    //built, sent and rejected by the payer
    //where the biometric route is not on offer, patient consent is the only route, as if the box were ticked
    const consentRoute = e.result['without_biometric'] == true || !this.biometricRouteOffered();
    if(consentRoute){
      const unanswered = this.unansweredMandatoryQuestionnaires(questionnaireData, stgquestionnaireData);
      if (unanswered.length > 0) {
      this.formService.alerts.error("Please answer every question in: " + unanswered.join(", "));
      return;
    }
    }

    if (!consentRoute && e.result['without_biometric'] == false) {
      const unanswered = this.unansweredMandatoryQuestionnaires(questionnaireData, stgquestionnaireData);
      if (unanswered.length == 0) {
        this.formService.alerts.error("Either proceed with biometric workflow or patient consent workflow");
        return;
      }
    }

    if(this.isEnhancement){
      this.buildEnhancementPayload(e, questionnaireData, stgquestionnaireData);
    }
    else if(this.formService.route.snapshot.queryParams.type && (this.formService.route.snapshot.queryParams.type == "resumit" || this.formService.route.snapshot.queryParams.type == "query")){
      this.questionairreData.forEach((questionnaire: any) => {
      if (questionnaire.items && questionnaire.items.length > 0) {
        questionnaire.items.forEach((item: any) => {
          item.value = this.getQuestionnaireValue(
            questionnaireData,
            item.linkId,
            questionnaire.text
          );
          this.attachmentTitleValue(item, questionnaireData, false);
        });
      }
    });

    this.stgquestionairreData.forEach((questionnaire: any) => {
      if (questionnaire.items && questionnaire.items.length > 0) {
        questionnaire.items.forEach((item: any) => {
          item.value = this.getstgQuestionnaireValue(
            stgquestionnaireData,
            item.linkId
          );
          this.attachmentTitleValue(item, stgquestionnaireData, true);
        });
      }
    });

    this.documentData.forEach(element => {
      if (e.result[element.code] != undefined) {
        element['text'] = e.result[element.code]
      }
      else{
        element['text'] = ""
      }
      this.applyDocumentCategory(element)
      //the requirement master's own title is replaced by the one the document was uploaded under
      element['document_title'] = this.documentTitleValue(e.result, element, "", element['text'] != "")
      delete e.result[element.code]
    });
    e.result['item_details'] = this.cardData['item_details']
    e.result['item_details'][0]['questionnaireList'] = this.questionairreData
      e.result['item_details'][0]['stgQuestionnaireList'] = this.stgquestionairreData
      e.result['item_details'][0]['documentList'] = this.documentData
      e.result['item_details'][0]['query_reply'] = e.result['query_reply']
    }
    else{
      this.questionairreData[0].questionnaireList.forEach((questionnaire: any) => {
      if (questionnaire.items && questionnaire.items.length > 0) {
        questionnaire.items.forEach((item: any) => {
          item.value = this.getQuestionnaireValue(
            questionnaireData,
            item.linkId
          );
          this.attachmentTitleValue(item, questionnaireData, false);
        });
      }
    });

    this.stgquestionairreData[0].questionnaireList.forEach((questionnaire: any) => {
      if (questionnaire.items && questionnaire.items.length > 0) {
        questionnaire.items.forEach((item: any) => {
          item.value = this.getstgQuestionnaireValue(
            stgquestionnaireData,
            item.linkId
          );
          this.attachmentTitleValue(item, stgquestionnaireData, true);
        });
      }
    });

    this.documentData[0].documentList.forEach(element => {
      if (e.result[element.code] != undefined) {
        element['text'] = e.result[element.code]
      }
      else{
        element['text'] = ""
      }
      this.applyDocumentCategory(element)
      //the requirement master's own title is replaced by the one the document was uploaded under
      element['document_title'] = this.documentTitleValue(e.result, element, "", element['text'] != "")
      delete e.result[element.code]
    });
    e.result['item_details'] = this.cardData['item_details']
    e.result['item_details'][0]['questionnaireList'] = this.questionairreData[0].questionnaireList
    e.result['item_details'][0]['stgQuestionnaireList'] = this.stgquestionairreData[0].questionnaireList
    e.result['item_details'][0]['documentList'] = this.documentData[0].documentList
    }
    //on an enhancement the amounts and the service period belong to each package row of the composite
    //array, not to a single parent-level package, so these parent fields do not exist to copy down.
    if (!this.isEnhancement) {
      e.result['item_details'][0]['price'] = e.result['price']
      e.result['item_details'][0]['service_validity'] = e.result['service_validity']
      e.result['item_details'][0]['net_amount'] = e.result['net_amount']
    }
    let nonCyclic = false
    let cyclic = false
    let nonStandalone = false
    let standalone = false
    let nonunsepecified = false
    let unspecified = false
    e.result['item_details'].forEach(element => {
      let modifierArray = []
      if(element.cyclicProcedure == "Y"){
        cyclic = true
      }
      else if(element.standalone == "Y"){
        standalone = true
      }
      else if(element.unspecified == "Y"){
        unspecified = true
      }
      else{
        nonCyclic = true
        nonStandalone = true
        nonunsepecified = true
      }
      if (element.qualifierCode && element.stratification) {
        let modifierList = {
          id: element["qualifierCode"],
          text: element["stratification"]
        }
        modifierArray.push(modifierList)
        element['modifier'] = modifierArray
      }
      if (element.categoryCode) {
        element['category'] = element.categoryCode
      }
    });
    if(nonCyclic && cyclic){
      this.formService.alerts.error("Cyclic and Non-Cyclic procedures cannot be submitted together.");
      return;
    }
    if(cyclic && e.result['item_details'].length > 1){
      this.formService.alerts.error("Only one Cyclic procedure can be submitted at a time.");
      return;
    }
    if(standalone && nonStandalone){
      this.formService.alerts.error("Standalone and Non-Standalone procedures cannot be submitted together.");
      return;
    }
    if(standalone && e.result['item_details'].length > 1){
      this.formService.alerts.error("Only one Standalone procedure can be submitted at a time.");
      return;
    }
    if(unspecified && nonunsepecified){
      this.formService.alerts.error("Unspecified and Non-Unspecified procedures cannot be submitted together.");
      return;
    }
    if(unspecified && e.result['item_details'].length > 1){
      this.formService.alerts.error("Only one Unspecified procedure can be submitted at a time.");
      return;
    }
    if(cyclic){
      e.result['cyclic_procedure'] = "Y"
    }
    else{
      e.result['cyclic_procedure'] = "N"
    }
    // Unspecified procedures (NHCX handbook 6.6): the provider's free-entry name replaces the
    // package display, which is what goes out as Claim.item[].productOrService.coding.display.
    // Shared by preauth, query reply and resubmission - all three submit through here.
    if (e.result['unspecifiedProcedureName']) {
      e.result['item_details'][0]['serviceItemName'] = e.result['unspecifiedProcedureName']
    }
    delete e.result['unspecifiedProcedureName']
    // e.result['item_details'] = this.cardData['item_details']
    // if(e.result['item_details']){
    //   e.result['item_details'] = e.result['implant_item_details']
    // }
    delete e.result['stg_questionnaire']
    delete e.result['questionnaire']
    delete e.result['treatment_query']
    this.loader.showSpinner();
    this.subscriptions.add(
      this.formService.baseService.action(e.result, "PREAUTHORIZATION_NHCX", "insurance", "preAuthorization_requests").subscribe(
        (data: any) => {
          if (data.errCode == -1) {
            this.loader.hideSpinner()
            this.formService.alerts.error(data.message);
          } else {
            this.loader.hideSpinner()
            this.formService.baseService.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
          }
        },
        (err: any) => {
          // A transport / server failure never reaches the success callback, so without this the submit
          // hangs behind the spinner: no alert, no navigation, and the form looks frozen after the
          // provider has already filled the whole authorization in.
          this.loader.hideSpinner()
          console.error("PREAUTHORIZATION_NHCX failed:", err);
          const serverMessage = typeof err?.error === "string" ? err.error : err?.error?.message;
          this.formService.alerts.error(serverMessage ? serverMessage : "Unable to submit the authorization request. Please try again.");
        })
    )
  }

  //An enhancement submits the whole package set, but only the packages the request arrived with carry the
  //three lists, each answering the one it was submitted with: row 0 in the bare control names the
  //resubmission flow already uses, every further such row under its own benefit-code namespace. A package
  //added on this enhancement was never asked anything, so its row goes out carrying none of them.
  buildEnhancementPayload(e: any, questionnaireData: any, stgquestionnaireData: any) {
    //All three lists are now each package's own, so all three are read back per row - out of the controls
    //that row's own blocks were rendered into. Nothing that was not rendered is answered: blocks the
    //approved package took with it when it left the array would otherwise put a set of empty answers, and
    //a list of unfilled document requirements, on every remaining package.
    //every uploader and title this build reads is noted here and cleared once all of them have been read
    this.consumedResultKeys = {};
    //the composite array writes its rows straight onto the result under its own field name; the record
    //is only the fallback for a form that was submitted without touching the array.
    let rows = Array.isArray(e.result['item_details']) && e.result['item_details'].length > 0
      ? e.result['item_details']
      : this.cardData['item_details'];
    //row 0 is the approved package and answers in the bare control names the resubmission and view flows
    //already use - unless it was removed from the array, in which case every remaining row is one added
    //here and nothing inherits its lists.
    let firstAddedRow = 0;
    if (this.recordPackagePresent && rows.length > 0) {
      rows[0]['stgQuestionnaireList'] = this.answerQuestionnaires(this.stgquestionairreData, stgquestionnaireData, true);
      rows[0]['questionnaireList'] = this.answerQuestionnaires(this.questionairreData, questionnaireData, false);
      //a package with no supporting documents leaves documentData undefined, and submitting must not
      //die on it the way iterating it unguarded would
      rows[0]['documentList'] = this.attachDocuments(this.documentData, e.result, "");
      firstAddedRow = 1;
    }
    for (let index = firstAddedRow; index < rows.length; index++) {
      const benefitCode = this.rowBenefitCode(rows[index]);
      const added = this.packageQuestionnaires[benefitCode];
      const keyPrefix = this.questionnaireKeyPrefix(benefitCode);
      rows[index]['questionnaireList'] = this.answerQuestionnaires(this.packageOrRecordList(added, 'questionnaires', this.questionairreData), questionnaireData, false, keyPrefix);
      rows[index]['stgQuestionnaireList'] = this.answerQuestionnaires(this.packageOrRecordList(added, 'stgQuestionnaires', this.stgquestionairreData), stgquestionnaireData, true, keyPrefix);
      rows[index]['documentList'] = this.attachDocuments(this.packageOrRecordList(added, 'documents', this.documentData), e.result, keyPrefix);
    }
    //Only now that every package has read them: an uploader two packages require is read twice, and
    //dropping it on the first read left the second with an empty document. They are the document list's,
    //not the request's own fields, so they must not go out at parent level either way.
    Object.keys(this.consumedResultKeys).forEach((key: string) => {
      delete e.result[key];
    });
    //held by reference up to here, so a row that was assigned one of the component's own lists cannot
    //keep pointing at it once the payload leaves. A row carrying no list keeps carrying none.
    rows.forEach((row: any) => {
      ['questionnaireList', 'stgQuestionnaireList', 'documentList'].forEach((key: string) => {
        if (row[key] != undefined) {
          row[key] = JSON.parse(JSON.stringify(row[key]));
        }
      });
    });
    e.result['item_details'] = rows;
  }

  //What a package submits for one of the three lists: its own where it has one, the approved package's
  //where it has none.
  //A requirement two packages share is rendered once - the first to claim it owns the controls - so a row
  //that carries no list of its own is carrying the same requirement as the package that was asked, not
  //carrying none. Handing it that list is what puts the single answer on both packages; without it the
  //shared questionnaire, STG questionnaire and documents went out on the claiming package alone. This is
  //also how every row was filled before the lists were split per package - each was handed the same
  //questionnaire and document list outright - so nothing is fetched here that the screen does not already
  //hold, and nothing is asked of the payer twice.
  //Inherited whether or not the approved package is still on the array, because sectionOwners renders it
  //on the same terms: take that package off and the inherited list is asked under the next owner's own
  //prefix instead, which is a control rename, not a requirement going away.
  packageOrRecordList(added: any, key: string, recordList: any): any[] {
    const own = added ? added[key] : undefined;
    if (Array.isArray(own) && own.length > 0) {
      return own;
    }
    return Array.isArray(recordList) ? recordList : [];
  }

  //NHCX needs a category on every supporting-information entry, and the plan's document requirement does
  //not carry one: GET_DOC_REQUIREMENT_LIST answers with the document's own code, display and text, so
  //there was never a category_code on these rows to save. The requirement's own category is used where
  //the master does return one, under either spelling, and the attachment code stands in where it does
  //not. category_display goes as it always has - it is the master's label for the UI, not part of what
  //the payer is sent, and the code is what identifies the category.
  applyDocumentCategory(element: any): void {
    const category = element['category_code'] ? element['category_code'] : element['category'];
    element['category_code'] = category ? category : DOCUMENT_CATEGORY_CODE;
    delete element.category_display;
  }

  //A package's uploads are read back out of the controls they were rendered into - namespaced for an
  //added package, bare for the record's - and land on the requirement's own code, so the payload keeps
  //the plan's naming. The uploader's value is lifted off the result and removed from it: these are
  //per-package now, so they must not also go out as parent-level fields.
  attachDocuments(documents: any, result: any, keyPrefix: string): any[] {
    if (!Array.isArray(documents)) {
      return [];
    }
    //Flattened to the requirements themselves, exactly as buildDocumentFields flattens them to build the
    //uploaders - so what is submitted is what was rendered. The two record shapes both reach here: the
    //enhancement path resolves its lists through documentSources and hands over the flat requirements,
    //while the fresh-preauth path assigns GET_DOC_REQUIREMENT_LIST's answer whole, a single wrapper row
    //carrying documentList. Iterating that wrapper read one entry that had no code of its own, which is
    //why only one document - and an empty one - was ever saved.
    const sources = this.documentSources(documents);
    sources.forEach(element => {
      //an uploader more than one package requires was rendered once, under the prefix of whichever
      //package claimed it - every package that requires it reads that one upload
      const askedPrefix = this.askedDocumentPrefix[element.code] != undefined ? this.askedDocumentPrefix[element.code].keyPrefix : keyPrefix;
      const key = askedPrefix + element.code;
      if (result[key] != undefined) {
        element['value'] = result[key]
      }
      else {
        element['value'] = ""
      }
      this.applyDocumentCategory(element)
      //the requirement master's own title is replaced by the one the document was uploaded under
      element['document_title'] = this.documentTitleValue(result, element, askedPrefix, element['value'] != "")
      //removed once every package has read it, not here - see consumedResultKeys
      this.consumedResultKeys[key] = true
    });
    return sources;
  }

  //A package's answers are read back out of the same composite its questions were rendered into, under
  //the control name they were rendered with - namespaced for an added package, bare for the record's.
  //The value lands on the item's linkId either way, so the payload keeps the plan's own naming.
  answerQuestionnaires(questionnaires: any, answers: any, stg: boolean, keyPrefix: string = ""): any[] {
    if (!Array.isArray(questionnaires)) {
      return [];
    }
    //Flattened the way buildSectionBlocks flattens the same lists to render them, so the set that is
    //answered is the set that was asked. A wrapper row from GET_QUESTIONNAIRE_LIST carries no items of
    //its own, so iterating it unflattened answered nothing at all.
    const sources = this.questionnaireSources(questionnaires);
    const asked = this.askedQuestionnairePrefix[stg ? "stgquestionnaire" : "questionnaire"];
    sources.forEach((questionnaire: any) => {
      //A questionnaire more than one package requires was rendered once, under the prefix of whichever
      //package claimed it - so that is where every package reads its answer from, and the one answer is
      //written onto each of their copies. A questionnaire only this package requires is read where it was
      //asked, under this package's own prefix.
      const identity = this.questionnaireIdentity(questionnaire);
      const askedPrefix = asked && asked[identity] != undefined ? asked[identity].keyPrefix : keyPrefix;
      if (questionnaire.items && questionnaire.items.length > 0) {
        questionnaire.items.forEach((item: any) => {
          const key = askedPrefix + item.linkId;
          item.value = stg
            ? this.getstgQuestionnaireValue(answers, key)
            : this.getQuestionnaireValue(answers, key, questionnaire.text);
          this.attachmentTitleValue(item, answers, stg, askedPrefix);
        });
      }
    });
    return sources;
  }

  //A question counts as answered when it holds something. false and 0 are answers - only an empty
  //control, or one that was never rendered, is not.
  isAnswered(value: any): boolean {
    return value !== "" && value !== undefined && value !== null;
  }

  //The mandatory questionnaires still holding an unanswered question, by title. The rendered claims are
  //what is walked, not each package's own list: a questionnaire several packages require is asked once,
  //so checking it once is checking it for all of them - and it is checked under the prefix it was
  //actually asked with, which is the only place its answer exists.
  unansweredMandatoryQuestionnaires(questionnaireData: any, stgquestionnaireData: any): string[] {
    const missing: string[] = [];
    const sections = [
      { namePrefix: "questionnaire", answers: questionnaireData, stg: false },
      { namePrefix: "stgquestionnaire", answers: stgquestionnaireData, stg: true }
    ];
    sections.forEach((section: any) => {
      const asked = this.askedQuestionnairePrefix[section.namePrefix];
      Object.keys(asked || {}).forEach((identity: string) => {
        const entry = asked[identity];
        if (MANDATORY_QUESTIONNAIRE_TEXTS.indexOf(entry.text) < 0) {
          return;
        }
        const unanswered = (entry.linkIds || []).some((linkId: string) => {
          const key = entry.keyPrefix + linkId;
          const value = section.stg
            ? this.getstgQuestionnaireValue(section.answers, key)
            : this.getQuestionnaireValue(section.answers, key);
          return !this.isAnswered(value);
        });
        if (unanswered) {
          missing.push(entry.title ? entry.title : entry.text);
        }
      });
    });
    return missing;
  }

  //The biometric route is on offer only where the screen has the biometric block (the enhancement layout
  //has none) and the decorator has not hidden it - nhcx_auth's valueChangeStart hides it for a request with
  //no eligibility behind it, so the same condition is read here, off the same formService. Until the form
  //is built that cannot be read, so it counts as offered; the visibility is re-applied once it is built.
  biometricRouteOffered(): boolean {
    const blocks = this.resourceDef && this.resourceDef.form && Array.isArray(this.resourceDef.form.blocks) ? this.resourceDef.form.blocks : [];
    if (!blocks.some((block: any) => block && block.name == "biometric_clearance")) {
      return false;
    }
    const formComponent: any = this.formComponenet;
    if (!formComponent || !formComponent.formService) {
      return true;
    }
    const cardData = formComponent.formService.cardData;
    return !!(cardData && cardData.data && cardData.data.preAuthorization_eligibility);
  }

  //Patient consent is the route taken when "without biometric" is ticked, or when there is no biometric
  //route to take at all - the mandatory questionnaires are then the only clearance there is.
  patientConsentRoute(): boolean {
    return this.withoutBiometric || !this.biometricRouteOffered();
  }

  //A mandatory questionnaire is asked only on the patient consent route; every other one always is.
  //An implant-excluded questionnaire is never asked while an implant or unspecified package is on the request.
  questionnaireBlockVisible(name: string, questionnaire: any): boolean {
    const gated = questionnaire != undefined && MANDATORY_QUESTIONNAIRE_TEXTS.indexOf(questionnaire.text) > -1;
    const excludable = questionnaire != undefined && IMPLANT_EXCLUDED_QUESTIONNAIRE_TEXTS.indexOf(questionnaire.text) > -1;
    this.biometricGatedBlocks[name] = gated;
    this.packageExcludableBlocks[name] = excludable;
    return !(excludable && this.packageExcludesQuestionnaires()) && (!gated || this.patientConsentRoute());
  }

  packageExcludesQuestionnaires(): boolean {
    return this.hasUnspecifiedPackage();
  }

  //The package rows on the form once it is built (so an enhancement's added or deleted packages count),
  //otherwise the ones the request arrived with.
  hasImplantPackage(): boolean {
    const formRows = this.packageRowsOnForm();
    const rows = formRows != undefined ? formRows : (this.cardData && Array.isArray(this.cardData['item_details']) ? this.cardData['item_details'] : []);
    return rows.some((row: any) => row && row.implantApplicable == "Y");
  }

  //Same rows as hasImplantPackage, for a package of the unspecified type.
  hasUnspecifiedPackage(): boolean {
    const formRows = this.packageRowsOnForm();
    const rows = formRows != undefined ? formRows : (this.cardData && Array.isArray(this.cardData['item_details']) ? this.cardData['item_details'] : []);
    return rows.some((row: any) => row && row.unspecified == "Y");
  }

  anyBlockVisible(blocks: any[]): boolean {
    return (blocks || []).some((block: any) => block && block.visible);
  }

  //The questionnaire sections are COMPOSITE-OBJECTs, which form.service builds into the parent form's own
  //fieldGroups (a block holding an array of child blocks), so the mandatory questionnaire blocks are
  //flipped in place there. A section is shown only while it still has a block in view, so unticking the
  //box cannot leave an empty Questionnaire accordion behind.
  //The package-excluded questionnaires go the same way: a child block's own visible is not honoured when
  //form.service builds a COMPOSITE-OBJECT (it takes the parent block's), so they too are flipped here once
  //the form is built. That goes for the biometric-gated blocks as well: every build and rebuild puts them
  //back on screen, so they are re-applied from withoutBiometric each time, not only when the box is ticked.
  applyBiometricQuestionnaireVisibility() {
    const formComponent: any = this.formComponenet;
    if (!formComponent || !Array.isArray(formComponent.fieldGroups)) {
      return;
    }
    this.applyBiometricFieldVisibility(formComponent);
    const excluded = this.packageExcludesQuestionnaires();
    formComponent.fieldGroups.forEach((section: any) => {
      if (!section || (section.name != "questionnaire" && section.name != "stg_questionnaire")) {
        return;
      }
      const childBlocks: any[] = [];
      (section.questions || []).forEach((question: any) => {
        if (Array.isArray(question)) {
          question.forEach((block: any) => childBlocks.push(block));
        }
      });
      childBlocks.forEach((block: any) => {
        if (!block) {
          return;
        }
        const gated = this.biometricGatedBlocks[block.name];
        const excludable = this.packageExcludableBlocks[block.name];
        if (!gated && !excludable) {
          return;
        }
        const visible = !(excludable && excluded) && (!gated || this.patientConsentRoute());
        if (block.visible != visible) {
          formComponent.setBlockVisibiltiy(block, visible);
        }
      });
      section.visible = this.anyBlockVisible(childBlocks);
    });
  }

  //The authentication type dropdown and the verify button are hidden by the checkbox's JSON dependents,
  //which run only when the checkbox itself changes. A rebuild (adding or deleting a package) builds the
  //fields afresh from the definition - dropdown shown, button hidden - and patchValue restores the tick
  //without firing those dependents, so the dropdown came back with the box still ticked. Re-applied here
  //from the control's value after every build. emit_change is off so the hidden dropdown's own
  //dependents are not re-fired with an empty value.
  applyBiometricFieldVisibility(formComponent: any) {
    const control = formComponent.form && formComponent.form.get != undefined ? formComponent.form.get('without_biometric') : undefined;
    if (control) {
      this.withoutBiometric = control.value == true;
    }
    else{
      this.withoutBiometric = false;
    }
    const authType = formComponent.form && formComponent.form.get != undefined ? formComponent.form.get('authentication_type_code') : undefined;
    const authTypeChosen = authType != undefined && ["face", "fingerprint", "iris"].indexOf(authType.value) > -1;
    if (!this.biometricRouteOffered()) {
      return;//the decorator has hidden the whole block - showing the dropdown would put its required check back
    }
    const visibility: any = {
      authentication_type_code: !this.withoutBiometric,
      biometric_auth_launch: !this.withoutBiometric && authTypeChosen
    };
    formComponent.fieldGroups.forEach((section: any) => {
      (section && Array.isArray(section.questions) ? section.questions : []).forEach((question: any) => {
        if (!question || Array.isArray(question) || visibility[question.key] == undefined) {
          return;
        }
        if (question.visible != visibility[question.key]) {
          formComponent.setFieldVisibiltiy(question, visibility[question.key], undefined, false);
        }
      });
    });
  }

  getBannerData(event) {
    debugger
  }

  questionValueChanged(data) {
    if (data && data.question && data.question.question && data.question.question.key == "without_biometric") {
      this.withoutBiometric = data.question.val == true;
      this.applyBiometricQuestionnaireVisibility();
    }
    // if(data && data.question && data.question.question.key == "net_amount" && data.question.val > 0 && data.form && data.form.controls && data.form.controls.net_amount && data.form.controls.net_amount.value != ""){
    //   data.form.controls.total_amount.setValue(data.form.controls.net_amount.value)
    // }
    if (!this.isEnhancement) {
      return;
    }
    //form-question relays a composite-array event as {val: {type, items, action}} - it drops the
    //question, so the event says nothing about which array fired. This also means the COMPOSITE-ARRAY
    //field must not be marked required, or form.component treats the event as a button state and never
    //emits - and it swallows the delete that empties a required array outright.
    const event = data && data.question ? data.question.val : undefined;
    if (!event || !Array.isArray(event.items)) {
      return;
    }
    if (event.action != 'ADD' && event.action != 'delete' && event.action != 'edit') {
      return;
    }
    //Any array on the screen may have fired, so nothing is read off the event: the package array is read
    //back by name from the form instead. composite-array propagates its value to the control after it
    //emits, hence the next tick - reading now would see the row that was just deleted still on it.
    setTimeout(() => this.syncPackageSections());
  }

  //The sections are brought in line with whatever the package array now holds, rather than being patched
  //per event: a package that was removed - or edited into a different benefit - takes its questions and
  //documents with it. Nothing is ever added here: the three lists belong to the packages the request
  //arrived with, so a package added on this enhancement contributes no section and is simply passed over.
  //This is idempotent, so an event from the diagnosis or implant array finds nothing to do.
  syncPackageSections() {
    if (!this.resourceDef || !this.resourceDef.form || this.syncingPackageSections) {
      return;
    }
    const rows = this.packageRowsOnForm();
    if (rows == undefined) {
      return;//no package array on this screen, or the form is not built yet - nothing to sync against
    }
    this.syncingPackageSections = true;
    try {
      this.applyPackageSections(rows);
      this.applyBiometricQuestionnaireVisibility();
    } finally {
      this.syncingPackageSections = false;
    }
  }

  private applyPackageSections(rows: any[]) {
    this.prunePackageQuestionnaires(rows);
    //The record's own questions and documents hold only while the package the authorization was
    //approved for is still on the array. It is matched by its benefit code where the record carries one
    //- falling back to "a row the request did not arrive with" only when it does not, since the array row
    //is then the sole trace of it. An emptied array leaves no procedure to ask about, so those go too.
    const recordCode = this.recordPackageCode();
    this.recordPackagePresent = recordCode
      ? rows.some((row: any) => this.rowBenefitCode(row) == recordCode)
      : rows.some((row: any) => this.packageQuestionnaires[this.rowBenefitCode(row)] == undefined);
    if (this.generatedSectionsSignature() != this.generatedSectionsBuiltFrom) {
      this.refreshGeneratedQuestionnaireBlocks();
    }
  }

  //The package array is bound by name, so the form is the one place that says which rows are packages
  //without having to tell one array's rows from another's by shape - all three screens name it
  //item_details. Rows with no benefit code yet are left out: there is nothing to ask the plan about.
  //undefined - not an empty list - when there is no such control to read, so a screen without the array
  //(or one whose form is not built yet) is left alone instead of being taken as an emptied array.
  //The package array's own value is watched rather than relying on the form's change event. When a
  //COMPOSITE-ARRAY field is marked required, form-question relays its add/edit/delete with the question
  //dropped (form-question.component.ts:456) and form.component reads that as a button press and never
  //emits questionValueChanged (form.component.ts:1528) - which is why deleting a package left its
  //questionnaire, STG questionnaire and documents standing on every layout that marks item_details
  //required. The control is replaced each time the form is rebuilt, so the watch moves with it.
  watchPackageRows(attempt: number = 0) {
    const formComponent: any = this.formComponenet;
    const control = formComponent && formComponent.form && formComponent.form.get != undefined ? formComponent.form.get('item_details') : undefined;
    if (!control) {
      //dhs-form builds its FormGroup a tick or two after it is handed the definition
      if (attempt < 10) {
        setTimeout(() => this.watchPackageRows(attempt + 1), 200);
      }
      return;
    }
    //the form is built (or has just been rebuilt), which resets every generated block to visible
    this.applyBiometricQuestionnaireVisibility();
    if (this.packageRowsControl == control) {
      return;//already watching this one
    }
    this.packageRowsSub?.unsubscribe();
    this.packageRowsControl = control;
    //Deferred a tick: the decorator rebuilds treatment_query off this same valueChanges, and its
    //subscription is the newer one, so it fires after this. A sync that rebuilds the form copies the old
    //form's values across, so run first it carried the deleted package's treatment_query row with it.
    this.packageRowsSub = control.valueChanges.subscribe(() => setTimeout(() => this.syncPackageSections()));
  }

  packageRowsOnForm(): any[] {
    const formComponent: any = this.formComponenet;
    const form = formComponent ? formComponent.form : undefined;
    const control = form && form.get != undefined ? form.get('item_details') : undefined;
    if (!control) {
      return undefined;
    }
    const rows = Array.isArray(control.value) ? control.value : [];
    return rows.filter((row: any) => this.rowBenefitCode(row) != "");
  }

  //What the generated sections were last built from. Comparing it is what catches blocks left standing
  //for a package that is no longer on the array - including the last one, where nothing else changed.
  generatedSectionsSignature(): string {
    const codes = Object.keys(this.packageQuestionnaires).sort();
    const packages = codes.map(code => {
      const added = this.packageQuestionnaires[code];
      return code + ":" + this.questionnaireSources(added.questionnaires).length + ":" + this.questionnaireSources(added.stgQuestionnaires).length + ":" + this.documentSources(added.documents).length;
    });
    //whether an implant or unspecified package is on the array decides which questionnaires are asked, so a change to it rebuilds too
    return (this.recordPackagePresent ? this.recordPackageCode() : "-") + "|" + packages.join(",") + "|" + (this.hasUnspecifiedPackage() ? "unspecified" : "-");
  }

  //drops every fetched package that is no longer on the array; answers to the questions it contributed
  //fall away with it, because the rebuilt FormGroup has no controls left for them to be patched into.
  prunePackageQuestionnaires(packageRows: any[]): boolean {
    const present: any = {};
    packageRows.forEach((row: any) => {
      present[this.rowBenefitCode(row)] = true;
    });
    let pruned = false;
    Object.keys(this.packageQuestionnaires).forEach(benefitCode => {
      //the approved package is answered through the record's lists, so an entry for it is a duplicate
      //that would render its questionnaire a second time
      if (!present[benefitCode] || this.isRecordPackage(benefitCode)) {
        delete this.packageQuestionnaires[benefitCode];
        pruned = true;
      }
    });
    return pruned;
  }

  //The questionnaire, STG questionnaire and documents belong to the packages the request arrived with, and
  //to those only: each one carries the three lists it was submitted with, answers and all. A request that
  //was already submitted with more than one package holds all of them on item_details - row 0 is read into
  //the record lists, and every further row is registered here, so the generated sections show every package
  //from the moment the screen opens instead of only after the array is touched.
  //A package added during this enhancement is deliberately absent: nothing was ever asked of it, so it
  //contributes no blocks here and its row goes out carrying none of the three lists.
  seedPackagesFromRecord() {
    const rows = this.cardData && Array.isArray(this.cardData['item_details']) ? this.cardData['item_details'] : [];
    rows.forEach((row: any) => {
      const benefitCode = this.rowBenefitCode(row);
      if (!benefitCode || this.isRecordPackage(benefitCode)) {
        return;
      }
      this.packageEntry(row);
    });
  }

  //A package's registration, taken from the row it arrived on. What the row carries is only the opening
  //state: resolveRecordLists reads every list back from the plan and overwrites these, so a row holding
  //nothing but refs and a row holding a full resolved list both end up showing what the plan currently
  //asks. Registering is idempotent: the resolver and the seed both come through here, and the first one
  //to run owns the entry.
  packageEntry(row: any): any {
    const benefitCode = this.rowBenefitCode(row);
    if (this.packageQuestionnaires[benefitCode] == undefined) {
      this.packageQuestionnaires[benefitCode] = {
        benefitName: this.rowBenefitName(row),
        questionnaires: this.questionnaireSources(row['questionnaireList']),
        stgQuestionnaires: this.questionnaireSources(row['stgQuestionnaireList']),
        documents: this.documentSources(row['documentList'])
      };
    }
    return this.packageQuestionnaires[benefitCode];
  }

  //The added package's STG questionnaire, scoped by its own category and benefit. If the insurance
  //service does not resolve one from categoryCode/benefitCode the response comes back empty and that
  //section is left exactly as it was.
  // fetchPackageStgQuestionnaire(row: any) {
  //   const benefitCode = this.rowBenefitCode(row);
  //   const payload = {
  //     'policyCode': this.cardData['policyNumber'],
  //     'recipientCode': this.cardData['payerCode'],
  //     'categoryCode': this.rowCategoryCode(row),
  //     'benefitCode': benefitCode
  //   };
  //   this.loader.showSpinner();
  //   this.subscriptions.add(
  //     this.formService.baseService.action(payload, "GET_QUESTIONNAIRE_FOR_PACKAGE", "insurance", "nhcx_plan_questionnaire").subscribe(
  //       (data: any) => {
  //         this.loader.hideSpinner();
  //         if (data && data.errCode == -1) {
  //           this.formService.alerts.error(data.message);
  //           return;
  //         }
  //         //normalised here, not at render time: the row that goes out in item_details has to carry
  //         //the same flat {title, items} list the record stores, not the API's wrapper row.
  //         const resolved = this.questionnaireSources(data ? data.resource : undefined);
  //         //a package that asks nothing of this kind contributes no block, but the sections still have to be
  //         //rebuilt: the row this one replaced was pruned before the fetch, so leaving them alone would keep
  //         //showing the questions of a package that is no longer on the request.
  //         if (resolved.length > 0 && this.packageQuestionnaires[benefitCode] != undefined) {
  //           this.packageQuestionnaires[benefitCode]['stgQuestionnaires'] = resolved;
  //         }
  //         this.refreshGeneratedQuestionnaireBlocks();
  //       },
  //       (err: any) => {
  //         this.loader.hideSpinner();
  //         console.error("GET_QUESTIONNAIRE_FOR_PACKAGE failed for benefit " + benefitCode + ":", err);
  //         this.formService.alerts.error("Unable to load the STG questionnaire for the selected package.");
  //         this.refreshGeneratedQuestionnaireBlocks();//the sections were pruned for this fetch - keep them in step
  //       })
  //   );
  // }

  //Both generated sections are regenerated together, then the form is refreshed once - a package can
  //bring plan questions, STG questions or both, and re-resolving the referred fields twice would make
  //the second pass fight the first.
  //What the two generated sections are, in one place: the initial render and every rebuild after an array
  //change read them from here, so neither can drift into building a section the other does not.
  questionnaireSectionDefinitions(): any[] {
    return [
      {
        blockName: "questionnaire",
        title: "Questionnaire",
        defName: this.questionnaireDefName(),
        recordSources: this.questionairreData,
        packageKey: "questionnaires",
        namePrefix: "questionnaire",
        fieldType: "question",
        //each package renders the questionnaire it was submitted with, under its own namespace
        perPackage: true,
        fallbackOrder: 6
      },
      {
        blockName: "stg_questionnaire",
        title: "STG Questionnaire",
        defName: this.stgQuestionnaireDefName(),
        recordSources: this.stgquestionairreData,
        packageKey: "stgQuestionnaires",
        namePrefix: "stgquestionnaire",
        fieldType: "stg",
        perPackage: true,//the only section a package brings its own of
        fallbackOrder: 7
      }
    ];
  }

  refreshGeneratedQuestionnaireBlocks() {
    this.generatedSectionsBuiltFrom = this.generatedSectionsSignature();
    //what each thing was asked under before this rebuild, so anything the rebuild re-homes onto another
    //package keeps the answer already given for it
    const previousQuestionnaire = this.askedQuestionnairePrefix;
    const previousDocument = this.askedDocumentPrefix;
    this.askedQuestionnairePrefix = {};
    this.questionnaireSectionDefinitions().forEach((section: any) => this.rebuildGeneratedQuestionnaireBlock(section));
    //the uploads belong to the approved package - buildDocumentFields returns nothing once that package
    //is off the array, which hides the block the same way an empty questionnaire section is hidden.
    const blocks = this.resourceDef.form.blocks;
    const documentIndex = blocks.findIndex((block: any) => block && block.name == "document_list");
    const documentOrder = documentIndex > -1 && blocks[documentIndex].order != undefined
      ? blocks[documentIndex].order
      : (this.requestType == "direct" ? 9 : 8);
    this.pendingControlRenames = this.controlRenames(previousQuestionnaire, previousDocument);
    this.placeBlock(this.documentBlock(this.buildDocumentFields(), documentOrder));
    this.baseService.getReferredField(this.resourceDef.form, (response) => {
      this.resourceDef.form['blocks'] = response;
      this.applyViewMode();//this callback replaces blocks, so re-apply the read-only flags
      this.rebuildFormControls();
    });
  }

  //Whether an accordion is open is held on the built block as default_open, not on the definition it
  //was built from, so a rebuild would collapse every section the provider had opened - including the
  //package one they are adding from. Blocks are keyed by name and occurrence, because this screen
  //repeats a couple of block names.
  blockOpenStateKeys(groups: any[]): string[] {
    const seen: any = {};
    return (groups || []).map((group: any) => {
      const name = group && group.name != undefined ? group.name : "";
      seen[name] = seen[name] == undefined ? 0 : seen[name] + 1;
      return name + "#" + seen[name];
    });
  }

  captureBlockOpenState(groups: any[]): any {
    const state: any = {};
    const keys = this.blockOpenStateKeys(groups);
    (groups || []).forEach((group: any, index: number) => {
      if (group && group.default_open != undefined) {
        state[keys[index]] = group.default_open;
      }
    });
    return state;
  }

  //sections generated since the state was captured keep whatever they were built with
  restoreBlockOpenState(groups: any[], state: any) {
    const keys = this.blockOpenStateKeys(groups);
    (groups || []).forEach((group: any, index: number) => {
      if (group && state[keys[index]] != undefined) {
        group.default_open = state[keys[index]];
      }
    });
  }

  //Regenerated blocks are only half the story: form.component builds its FormGroup in ngOnInit and
  //takes it as an @Input, and its ngOnChanges on [data] rebuilds the field groups without rebuilding
  //that FormGroup. Rendering new questions against the old controls is what raises
  //"cannot read properties of undefined (reading 'touched')" out of form-question's isValid. So both
  //are rebuilt here from the same block set, through the form's own services, and the values already
  //entered are patched back in - patchValue ignores keys that have no control, so rows and answers
  //that survived the rebuild come back and anything dropped simply does not.
  rebuildFormControls() {
    const formComponent: any = this.formComponenet;
    if (!formComponent || !formComponent.fieldGroup) {
      return;
    }
    const entered = formComponent.form && formComponent.form.getRawValue != undefined ? formComponent.form.getRawValue() : {};
    this.applyControlRenames(entered);
    const openState = this.captureBlockOpenState(formComponent.fieldGroups);
    formComponent.fieldGroups = formComponent.formService.buildFormGroup(formComponent, formComponent.fieldGroup);
    this.restoreBlockOpenState(formComponent.fieldGroups, openState);
    formComponent.blockMapping = formComponent.fieldGroups;
    formComponent.form = formComponent.qcs.toFormGroup(formComponent.fieldGroups, formComponent.action);
    formComponent.formService.form = formComponent.form;//ngOnChanges keeps these two in step, so do we
    formComponent.form.patchValue(entered);
    this.config.formGroup = formComponent.form;//getDataFn's copy, used when the payload is assembled
    this.watchPackageRows();//the control this was watching has just been replaced
    this.watchTitledUploaders();//as have the uploaders - patchValue above has already restored the titles
  }

  //Every block a generated section stands on: the approved package's, then one group per package added
  //to it. Both the initial render and every rebuild after an array change build from here, so a request
  //that is opened already carrying two packages shows exactly what adding the second one would have.
  buildSectionBlocks(section: any): any[] {
    //The record's own section rides with the approved package: take that package off the array and the
    //record stops being an owner. Its list is still resolved, because a package that carries none of its
    //own inherits it - what leaves with the approved package is its turn to ask, not the requirement.
    const recordSources = this.questionnaireSources(section.recordSources);
    const owners = this.sectionOwners(this.recordPackagePresent ? recordSources : [], section.packageKey, section.perPackage, recordSources);
    owners.forEach((owner: any) => {
      owner.sources = this.questionnaireSources(owner.sources);
    });
    //First pass decides who asks what. A questionnaire more than one package requires is asked once, by
    //the first owner to reach it, and the rest simply require the answer it is given.
    const asked: any = {};
    owners.forEach((owner: any) => {
      owner.sources.forEach((questionnaire: any) => {
        const identity = this.questionnaireIdentity(questionnaire);
        if (asked[identity] == undefined) {
          const items = Array.isArray(questionnaire.items) ? questionnaire.items : [];
          asked[identity] = {
            keyPrefix: owner.keyPrefix,
            linkIds: items.map((item: any) => item.linkId),
            text: questionnaire.text,
            title: questionnaire.title
          };
        }
      });
    });
    this.askedQuestionnairePrefix[section.namePrefix] = asked;
    //Second pass renders. Each owner builds only what it was the one to claim, so a shared questionnaire
    //appears once; it is headed with no package name, because it belongs to every package that requires
    //it rather than to the one that happens to ask it.
    //Each questionnaire is headed with its own title and nothing else. Naming a package there made sense
    //while every package repeated its own copy; now that one asked once stands for all of them, the
    //package that happens to be asking it is an implementation detail - and on a shared questionnaire it
    //would name only one of the packages the answer actually goes to.
    const sectionBlocks: any[] = [];
    const rendered: any = {};
    owners.forEach((owner: any) => {
      //once per questionnaire, whoever claimed it - a package listing the same one twice still asks once
      const claimed = owner.sources.filter((questionnaire: any) => {
        const identity = this.questionnaireIdentity(questionnaire);
        if (rendered[identity] || asked[identity].keyPrefix != owner.keyPrefix) {
          return false;
        }
        rendered[identity] = true;
        return true;
      });
      const namePrefix = section.namePrefix + (owner.namePrefixSuffix ? owner.namePrefixSuffix : "");
      this.buildQuestionnaireBlocks(claimed, namePrefix, section.fieldType, owner.keyPrefix)
        .forEach((block: any) => sectionBlocks.push(block));
    });
    return sectionBlocks;
  }

  //Which questionnaire and document controls moved from one package's naming to another's in this
  //rebuild. A questionnaire's answers live nested under the block it was asked in (e.result.questionnaire
  /// e.result.stg_questionnaire); a document's uploader and title are controls of the form itself. Only
  //things asked both before and after are listed - anything that genuinely went away with its package has
  //no new home to carry an answer to.
  controlRenames(previousQuestionnaire: any, previousDocument: any): any[] {
    const renames: any[] = [];
    //the block a section's answers are nested under, which is not the prefix its controls are named with
    const containers: any = { questionnaire: "questionnaire", stgquestionnaire: "stg_questionnaire" };
    Object.keys(containers).forEach((namePrefix: string) => {
      const before = previousQuestionnaire ? previousQuestionnaire[namePrefix] : undefined;
      const after = this.askedQuestionnairePrefix[namePrefix];
      if (!before || !after) {
        return;
      }
      Object.keys(before).forEach((identity: string) => {
        if (after[identity] == undefined || after[identity].keyPrefix == before[identity].keyPrefix) {
          return;
        }
        const from = before[identity].keyPrefix;
        const to = after[identity].keyPrefix;
        (before[identity].linkIds || []).forEach((linkId: string) => {
          renames.push({ container: containers[namePrefix], oldKey: from + linkId, newKey: to + linkId });
          //an attachment question carries a title control beside it
          renames.push({ container: containers[namePrefix], oldKey: this.documentTitleKey(linkId, from), newKey: this.documentTitleKey(linkId, to) });
        });
      });
    });
    Object.keys(previousDocument || {}).forEach((code: string) => {
      const after = this.askedDocumentPrefix[code];
      if (after == undefined || after.keyPrefix == previousDocument[code].keyPrefix) {
        return;
      }
      const from = previousDocument[code].keyPrefix;
      const to = after.keyPrefix;
      renames.push({ container: "", oldKey: from + code, newKey: to + code });
      renames.push({ container: "", oldKey: this.documentTitleKey(code, from), newKey: this.documentTitleKey(code, to) });
    });
    return renames;
  }

  //patchValue matches by control name, so a value still filed under the name it was entered against is
  //simply ignored by the rebuilt form. Moving it first is what lets a shared questionnaire keep its
  //answers when the package that happened to be asking it is deleted or edited away.
  applyControlRenames(entered: any) {
    if (!entered || this.pendingControlRenames.length == 0) {
      return;
    }
    this.pendingControlRenames.forEach((rename: any) => {
      const holder = rename.container ? entered[rename.container] : entered;
      if (!holder || typeof holder != 'object' || holder[rename.oldKey] == undefined) {
        return;
      }
      if (holder[rename.newKey] == undefined || holder[rename.newKey] === "") {
        holder[rename.newKey] = holder[rename.oldKey];
      }
      delete holder[rename.oldKey];
    });
    this.pendingControlRenames = [];
  }

  //A generated section is a COMPOSITE-OBJECT bound to a saved definition, so growing it means
  //regenerating that definition under the same name and swapping the parent block back in, which is
  //what makes getReferredField resolve it afresh.
  rebuildGeneratedQuestionnaireBlock(section: any) {
    const sectionBlocks = this.buildSectionBlocks(section);
    this.formService.baseService.saveJsonDef(section.defName, {
      resource: section.defName,
      form: {
        blocks: sectionBlocks
      },
      list: {
        fields: []
      }
    });
    const blocks = this.resourceDef.form.blocks;
    const current = blocks.findIndex((block: any) => block && block.name == section.blockName);
    const order = current > -1 && blocks[current].order != undefined ? blocks[current].order : section.fallbackOrder;
    //the section may have been hidden because the record carried no list of this kind - a package that
    //asks questions has to bring it back into view.
    this.placeBlock(this.compositeQuestionnaireBlock(section.blockName, section.title, section.defName, order, this.anyBlockVisible(sectionBlocks)));
  }

  ngOnDestroy() {
    // this.resetDublicasyHistory();
    this.packageRowsSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    this.communicationService.emitSidebar({ sidebar: true });
    //the modal teardown this used to do itself is the first thing the base does, and skipping the rest
    //of it is what leaked: hasSubscription, routeParamsSubscription, the dialog ref, the dynamically
    //created components and the barcode keydown listener all outlive the screen without this call.
    super.ngOnDestroy();
  }
}
